webpackJsonp([1],{

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var http_1 = __webpack_require__(33);
var handle_error_1 = __webpack_require__(86);
var ThemeService = /** @class */ (function () {
    function ThemeService(http) {
        this.http = http;
        this.themesUrl = "api/themes"; // url to web api
        this._activeTheme = JSON.parse(localStorage.getItem("active_theme"));
    }
    Object.defineProperty(ThemeService.prototype, "primaryColour", {
        get: function () {
            return (this._activeTheme
                && this._activeTheme.primaryColour)
                ? this._activeTheme.primaryColour
                : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThemeService.prototype, "navbarLogo", {
        get: function () {
            return (this._activeTheme
                && this._activeTheme.navbarLogo
                && this._activeTheme.navbarLogo.fileContentBase64)
                ? "data:image/png;base64," + this._activeTheme.navbarLogo.fileContentBase64
                : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThemeService.prototype, "activeTheme", {
        set: function (value) {
            // save to localStorage incase user refreshes the browser
            localStorage.setItem("active_theme", JSON.stringify(value));
            this._activeTheme = value;
        },
        enumerable: true,
        configurable: true
    });
    ThemeService.prototype.getTheme = function () {
        var _this = this;
        return this.http.get(this.themesUrl)
            .toPromise()
            .then(function (theme) {
            _this.activeTheme = theme;
            return theme;
        })
            .catch(handle_error_1.handleError);
    };
    ThemeService.prototype.removeActiveTheme = function () {
        localStorage.removeItem("active_theme");
        this._activeTheme = null;
    };
    ThemeService.prototype.update = function (theme) {
        var _this = this;
        return this.http.post(this.themesUrl, theme)
            .toPromise()
            .then(function () {
            // only replace the whole theme object if user attempted to upload a logo as part of the form submission,
            // to prevent the current logo from disappearing.
            if (theme.navbarLogo != null) {
                _this.activeTheme = theme;
            }
            else {
                _this._activeTheme.primaryColour = theme.primaryColour;
            }
        })
            .catch(handle_error_1.handleError);
    };
    ThemeService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient])
    ], ThemeService);
    return ThemeService;
}());
exports.ThemeService = ThemeService;


/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var ValidationHelperService = /** @class */ (function () {
    function ValidationHelperService() {
    }
    // https://github.com/angular/angular/issues/11774#issuecomment-264706699
    ValidationHelperService.prototype.markAllTouched = function (control) {
        if (control.hasOwnProperty("controls")) {
            control.markAsTouched({ onlySelf: true }); // mark group
            var ctrl = control;
            for (var inner in ctrl.controls) {
                this.markAllTouched(ctrl.controls[inner]);
            }
        }
        else {
            (control).markAsTouched({ onlySelf: true });
        }
    };
    ValidationHelperService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [])
    ], ValidationHelperService);
    return ValidationHelperService;
}());
exports.ValidationHelperService = ValidationHelperService;


/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var common_1 = __webpack_require__(3);
var ngx_color_picker_1 = __webpack_require__(271);
var flex_layout_1 = __webpack_require__(255);
var forms_1 = __webpack_require__(17);
var faw_material_module_1 = __webpack_require__(626);
var SharedModule = /** @class */ (function () {
    function SharedModule() {
    }
    SharedModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                ngx_color_picker_1.ColorPickerModule,
                flex_layout_1.FlexLayoutModule,
                forms_1.ReactiveFormsModule,
                faw_material_module_1.FAWMaterialModule,
            ],
            exports: [
                common_1.CommonModule,
                ngx_color_picker_1.ColorPickerModule,
                flex_layout_1.FlexLayoutModule,
                forms_1.ReactiveFormsModule,
                faw_material_module_1.FAWMaterialModule,
            ]
        })
    ], SharedModule);
    return SharedModule;
}());
exports.SharedModule = SharedModule;


/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var router_1 = __webpack_require__(26);
var auth_service_1 = __webpack_require__(85);
var AuthGuard = /** @class */ (function () {
    function AuthGuard(authService, router) {
        this.authService = authService;
        this.router = router;
    }
    AuthGuard.prototype.canActivate = function (route, state) {
        var url = state.url;
        return this.checkLogin(url);
    };
    AuthGuard.prototype.checkLogin = function (url) {
        if (this.authService.loggedIn()) {
            return true;
        }
        this.authService.redirectUrl = url;
        this.router.navigate(["/login"]);
        return false;
    };
    AuthGuard = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [auth_service_1.AuthService, router_1.Router])
    ], AuthGuard);
    return AuthGuard;
}());
exports.AuthGuard = AuthGuard;


/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
// http://stackoverflow.com/a/40287063
exports.role = new core_1.InjectionToken("role");
exports.Role = {
    webUser: "WebUser",
    webAdmin: "WebAdmin",
    internalStaff: "InternalStaff"
};


/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var http_1 = __webpack_require__(33);
var handle_error_1 = __webpack_require__(86);
var UserService = /** @class */ (function () {
    function UserService(http) {
        this.http = http;
        this.usersUrl = "api/users"; // url to web api
    }
    UserService.prototype.getUser = function (id) {
        var url = this.usersUrl + "/" + id;
        return this.http.get(url)
            .toPromise()
            .catch(handle_error_1.handleError);
    };
    UserService.prototype.getListing = function () {
        return this.http.get(this.usersUrl)
            .toPromise()
            .catch(handle_error_1.handleError);
        ;
    };
    UserService.prototype.getOptions = function () {
        var url = this.usersUrl + "/options";
        return this.http.get(url)
            .toPromise()
            .catch(handle_error_1.handleError);
    };
    UserService.prototype.resetPassword = function (userID) {
        var url = this.usersUrl + "/" + userID + "/reset-password";
        return this.http.post(url, null)
            .toPromise()
            .catch(handle_error_1.handleError);
    };
    UserService.prototype.update = function (user) {
        var url = this.usersUrl + "/" + user.id;
        return this.http.put(url, user)
            .toPromise()
            .then(function () { return user; })
            .catch(handle_error_1.handleError);
    };
    UserService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient])
    ], UserService);
    return UserService;
}());
exports.UserService = UserService;


/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var forms_1 = __webpack_require__(17);
var material_1 = __webpack_require__(29);
var auth_service_1 = __webpack_require__(85);
var snack_bar_service_1 = __webpack_require__(44);
var validation_helper_service_1 = __webpack_require__(108);
var ChangePasswordDialogComponent = /** @class */ (function () {
    function ChangePasswordDialogComponent(authService, fb, snackBarService, validationHelperService, data, dialogRef) {
        this.authService = authService;
        this.fb = fb;
        this.snackBarService = snackBarService;
        this.validationHelperService = validationHelperService;
        this.data = data;
        this.dialogRef = dialogRef;
        this.changePasswordForm = this.fb.group({
            newPassword: ['', [forms_1.Validators.required, forms_1.Validators.maxLength(100)]],
            confirmPassword: ['', [forms_1.Validators.required, forms_1.Validators.maxLength(100)]],
        }, { validator: this.checkPasswords }); // see https://stackoverflow.com/a/43493648
    }
    ChangePasswordDialogComponent.prototype.ngOnInit = function () {
        this.passwordChangeMandatory = this.data.passwordChangeMandatory;
    };
    Object.defineProperty(ChangePasswordDialogComponent.prototype, "newPasswordFC", {
        get: function () { return this.changePasswordForm.get("newPassword"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChangePasswordDialogComponent.prototype, "confirmPasswordFC", {
        get: function () { return this.changePasswordForm.get("confirmPassword"); },
        enumerable: true,
        configurable: true
    });
    ChangePasswordDialogComponent.prototype.actionsDisabled = function () {
        return this.loading;
    };
    ChangePasswordDialogComponent.prototype.checkPasswords = function (group) {
        var newPassword = group.get("newPassword").value;
        var confirmPassword = group.get("confirmPassword").value;
        return newPassword === confirmPassword ? null : { notSame: true };
    };
    ChangePasswordDialogComponent.prototype.onSubmit = function () {
        var _this = this;
        if (this.changePasswordForm.invalid) {
            this.validationHelperService.markAllTouched(this.changePasswordForm);
            return;
        }
        this.loading = true;
        var dto = this.changePasswordForm.value;
        this.authService.changePassword(dto)
            .then(function () {
            _this.loading = false;
            _this.snackBarService.openSnackBar("Password updated.");
            _this.dialogRef.close();
        })
            .catch(function (err) {
            _this.loading = false;
            _this.snackBarService.openSnackBar(err);
        });
    };
    ChangePasswordDialogComponent.prototype.showPasswordMismatchError = function () {
        return this.confirmPasswordFC.touched && this.changePasswordForm.hasError("notSame");
    };
    ChangePasswordDialogComponent.prototype.showSpinner = function () {
        return this.loading;
    };
    ChangePasswordDialogComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(628),
            styles: [__webpack_require__(629)]
        }),
        __param(4, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [auth_service_1.AuthService,
            forms_1.FormBuilder,
            snack_bar_service_1.SnackBarService,
            validation_helper_service_1.ValidationHelperService, Object, material_1.MatDialogRef])
    ], ChangePasswordDialogComponent);
    return ChangePasswordDialogComponent;
}());
exports.ChangePasswordDialogComponent = ChangePasswordDialogComponent;


/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var http_1 = __webpack_require__(33);
var operators_1 = __webpack_require__(6);
var handle_error_1 = __webpack_require__(86);
var EnquiryService = /** @class */ (function () {
    function EnquiryService(http) {
        this.http = http;
        this.enquiriesUrl = "api/enquiries"; // url to web api
        this.defaultEnquiry = {
            id: null,
            enquiryNumber: null,
            introducerRateChartID: null,
            assetTypeGroupID: null,
            costOfGoods: null,
            isAdvance: null,
            paymentFrequencyID: null,
            repayment: null,
            term: null,
            contactName: null,
            businessName: null,
            emailAddress: null,
            submittedOn: null,
        };
    }
    EnquiryService.prototype.create = function (enq) {
        return this.http.post(this.enquiriesUrl, enq)
            .toPromise()
            .catch(handle_error_1.handleError);
    };
    EnquiryService.prototype.getEnquiry = function (id) {
        if (!id) {
            return Promise.resolve(this.defaultEnquiry);
        }
        var url = this.enquiriesUrl + "/" + id;
        return this.http.get(url)
            .toPromise()
            .catch(handle_error_1.handleError);
    };
    // Virtual scroll EnquiryListing implementation - removed for now, since generated SQL is not compatible with SQL2008R2
    //getListing(skip: number, take: number, sortBy: string, sortDirection: string, searchString: string): Observable<VirtualRepeatContainer<EnquiryListing>> {
    //    return this.http.get<VirtualRepeatContainer<EnquiryListing>>(this.enquiriesUrl, {
    //        params: new HttpParams()
    //            .set("skip", (skip != null) ? String(skip) : "")
    //            .set("take", (take != null) ? String(take) : "")
    //            .set("sortBy", (sortBy != null) ? String(sortBy) : "")
    //            .set("sortDirection", (sortDirection != null) ? String(sortDirection) : "")
    //            .set("searchString", (searchString != null) ? String(searchString) : "")
    //    })
    //    .catch(handleError);;
    //}
    EnquiryService.prototype.getListing = function (monthsAgo) {
        return this.http.get(this.enquiriesUrl, {
            params: new http_1.HttpParams().set("monthsAgo", (monthsAgo != null) ? String(monthsAgo) : "")
        })
            .toPromise()
            .catch(handle_error_1.handleError);
        ;
    };
    EnquiryService.prototype.getOptions = function () {
        var url = this.enquiriesUrl + "/options";
        return this.http.get(url)
            .toPromise()
            .catch(handle_error_1.handleError);
    };
    EnquiryService.prototype.getRepaymentOptions = function (calcParams) {
        return this.http.post(this.enquiriesUrl + "/repayments", calcParams)
            .pipe(operators_1.catchError(handle_error_1.handleError));
    };
    EnquiryService.prototype.submit = function (enq) {
        return this.http
            .post(this.enquiriesUrl + "/submit", enq, {
            params: new http_1.HttpParams().set("id", (enq.id != null ? String(enq.id) : ""))
        })
            .toPromise()
            .catch(handle_error_1.handleError);
    };
    EnquiryService.prototype.update = function (enq) {
        var url = this.enquiriesUrl + "/" + enq.id;
        return this.http.put(url, enq)
            .toPromise()
            .then(function () { return enq; })
            .catch(handle_error_1.handleError);
    };
    EnquiryService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient])
    ], EnquiryService);
    return EnquiryService;
}());
exports.EnquiryService = EnquiryService;


/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var http_1 = __webpack_require__(33);
var operators_1 = __webpack_require__(6);
var handle_error_1 = __webpack_require__(86);
var DocumentService = /** @class */ (function () {
    function DocumentService(http) {
        this.http = http;
        this.enquiriesUrl = "api/enquiries"; // url to web api
    }
    DocumentService.prototype.downloadApplicationForm = function (enquiryID) {
        var url = this.enquiriesUrl + "/" + enquiryID + "/application";
        return this.http
            .get(url, {
            responseType: "blob",
            observe: "response",
            headers: new http_1.HttpHeaders().set("Accept", "application/pdf")
        })
            .pipe(operators_1.catchError(handle_error_1.handleError));
    };
    DocumentService.prototype.downloadQuotePdf = function (enquiryID, docGenData) {
        var url = this.enquiriesUrl + "/" + enquiryID + "/pdf";
        return this.http
            .post(url, docGenData, {
            responseType: "blob",
            observe: "response",
            headers: new http_1.HttpHeaders().set("Accept", "application/pdf")
        })
            .pipe(operators_1.catchError(handle_error_1.handleError));
    };
    DocumentService.prototype.prepareQuoteDocGenData = function (showAssetCost, checkboxValues, repaymentOptions) {
        // includeRepaymentOpts will contain all the repayment options, but unchecked ones will be null
        var includeRepaymentOpts = checkboxValues.map(function (checked, index) {
            if (checked) {
                return Object.assign({}, repaymentOptions[index]);
            }
        });
        var docGenData = {
            showAssetCost: showAssetCost,
            repaymentOptions: includeRepaymentOpts.filter(function (r) { return r != null; })
        };
        return docGenData;
    };
    DocumentService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient])
    ], DocumentService);
    return DocumentService;
}());
exports.DocumentService = DocumentService;


/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var http_1 = __webpack_require__(33);
var handle_error_1 = __webpack_require__(86);
var EmailService = /** @class */ (function () {
    function EmailService(http) {
        this.http = http;
        this.enquiriesUrl = "api/enquiries"; // url to web api
    }
    EmailService.prototype.getListing = function (enquiryID) {
        var url = this.enquiriesUrl + "/" + enquiryID + "/emails";
        return this.http.get(url)
            .toPromise()
            .catch(handle_error_1.handleError);
    };
    EmailService.prototype.sendEmail = function (enquiryID, email) {
        var url = this.enquiriesUrl + "/" + enquiryID + "/emails";
        return this.http.post(url, email)
            .toPromise()
            .catch(handle_error_1.handleError);
    };
    EmailService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient])
    ], EmailService);
    return EmailService;
}());
exports.EmailService = EmailService;


/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var forms_1 = __webpack_require__(17);
var router_1 = __webpack_require__(26);
var snack_bar_service_1 = __webpack_require__(44);
var theme_service_1 = __webpack_require__(107);
var ThemeSettingsComponent = /** @class */ (function () {
    function ThemeSettingsComponent(fb, router, snackBarService, themeService) {
        this.fb = fb;
        this.router = router;
        this.snackBarService = snackBarService;
        this.themeService = themeService;
        this.fileInputFC = new forms_1.FormControl();
        this.themeForm = this.fb.group({
            primaryColour: ['', forms_1.Validators.maxLength(20)],
            navbarLogo: null
        });
    }
    ThemeSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loading = true;
        this.themeService.getTheme()
            .then(function (theme) {
            _this.loading = false;
            _this.themeSettings = theme;
            _this.primaryColourFC.setValue(theme.primaryColour);
        })
            .catch(function (err) {
            _this.loading = false;
            _this.snackBarService.openSnackBar("Error retrieving theme settings.");
        });
    };
    Object.defineProperty(ThemeSettingsComponent.prototype, "primaryColourFC", {
        get: function () { return this.themeForm.get("primaryColour"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThemeSettingsComponent.prototype, "navbarLogoFC", {
        get: function () { return this.themeForm.get("navbarLogo"); },
        enumerable: true,
        configurable: true
    });
    ThemeSettingsComponent.prototype.actionsDisabled = function () {
        return this.showLoadingSpinner()
            || this.showSaveSpinner();
    };
    ThemeSettingsComponent.prototype.getPreviewLogo = function () {
        var imagePreview = null;
        if (this.navbarLogoFC != null && this.navbarLogoFC.value != null) {
            var selectedFile = this.navbarLogoFC.value;
            imagePreview = "data:image/png;base64," + selectedFile.fileContentBase64;
        }
        return imagePreview;
    };
    ThemeSettingsComponent.prototype.goToEnquiriesList = function () {
        this.router.navigate(["/enquiries"]);
    };
    ThemeSettingsComponent.prototype.validImageFile = function (imgFile) {
        return (imgFile.type === "image/png"
            && imgFile.size <= 100000);
    };
    // refer to docs for File obj structure https://developer.mozilla.org/en-US/docs/Web/API/File
    // code modified from https://nehalist.io/uploading-files-in-angular2/
    ThemeSettingsComponent.prototype.onFileChange = function (event) {
        var _this = this;
        var reader = new FileReader();
        if (event.target.files && event.target.files.length > 0) {
            var file_1 = event.target.files[0];
            reader.readAsDataURL(file_1); // see https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
            reader.onload = function () {
                if (_this.validImageFile(file_1)) {
                    _this.navbarLogoFC.setValue({
                        fileName: file_1.name,
                        fileType: file_1.type,
                        // readAsDataURL() returns a string in the form "data:image/png;base64,JVBERi0x..."
                        fileContentBase64: reader.result.split(',')[1]
                    });
                }
                else {
                    _this.snackBarService.openSnackBar("Logo must be PNG and less than 100KB.");
                }
                _this.fileInputFC.reset();
            };
        }
    };
    ThemeSettingsComponent.prototype.save = function () {
        //if (this.themeForm.invalid()) {
        //    //this.validationHelperService.markAllTouched(this.themeForm);
        //    this.snackBarService.openSnackBar("Please fill in required values.");
        //    return;
        //}
        var _this = this;
        this.loadingSave = true;
        var themeSettings = this.themeForm.value;
        this.themeService.update(themeSettings)
            .then(function () {
            _this.loadingSave = false;
            _this.snackBarService.openSnackBar("Theme settings updated.");
        })
            .catch(function (err) {
            _this.loadingSave = false;
            _this.snackBarService.openSnackBar(err);
        });
    };
    ThemeSettingsComponent.prototype.showLoadingSpinner = function () {
        return this.loading;
    };
    ThemeSettingsComponent.prototype.showSaveSpinner = function () {
        return this.loadingSave;
    };
    ThemeSettingsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(619),
            styles: [__webpack_require__(620)]
        }),
        __metadata("design:paramtypes", [forms_1.FormBuilder,
            router_1.Router,
            snack_bar_service_1.SnackBarService,
            theme_service_1.ThemeService])
    ], ThemeSettingsComponent);
    return ThemeSettingsComponent;
}());
exports.ThemeSettingsComponent = ThemeSettingsComponent;


/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var forms_1 = __webpack_require__(17);
var router_1 = __webpack_require__(26);
var material_1 = __webpack_require__(29);
var rxjs_1 = __webpack_require__(4);
var operators_1 = __webpack_require__(6);
var confirm_dialog_component_1 = __webpack_require__(274);
var user_service_1 = __webpack_require__(178);
var snack_bar_service_1 = __webpack_require__(44);
var validation_helper_service_1 = __webpack_require__(108);
var UserDetailComponent = /** @class */ (function () {
    function UserDetailComponent(activatedRoute, dialog, fb, userService, router, snackBarService, validationHelperService) {
        this.activatedRoute = activatedRoute;
        this.dialog = dialog;
        this.fb = fb;
        this.userService = userService;
        this.router = router;
        this.snackBarService = snackBarService;
        this.validationHelperService = validationHelperService;
        this.ngUnsubscribe = new rxjs_1.Subject(); //see https://stackoverflow.com/a/41177163
        this.userForm = this.fb.group({
            username: '',
            nameTitleCode: '',
            firstName: ['', [forms_1.Validators.required, forms_1.Validators.maxLength(60)]],
            middleName: ['', forms_1.Validators.maxLength(60)],
            lastName: ['', [forms_1.Validators.required, forms_1.Validators.maxLength(60)]],
            emailAddress: ['', [forms_1.Validators.required, forms_1.Validators.maxLength(100)]],
            phoneNumber: ['', forms_1.Validators.maxLength(20)],
            mobileNumber: ['', forms_1.Validators.maxLength(20)],
            jobTitle: ['', forms_1.Validators.maxLength(250)],
            isWebAdmin: false,
            isActive: false,
            isLocked: false,
            temporaryPassword: ''
        });
    }
    UserDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loading = true;
        this.userService.getOptions()
            .then(function (opts) {
            _this.userOpts = opts;
            _this.activatedRoute.paramMap
                .pipe(operators_1.switchMap(function (params) { return _this.userService.getUser(+params.get("id")); }), // (+) converts string "id" to a number
            operators_1.takeUntil(_this.ngUnsubscribe))
                .subscribe(function (user) {
                _this.loading = false;
                _this.user = user;
                _this.userForm.patchValue(user);
                _this.userForm.get("username").disable();
                _this.temporaryPasswordFC.disable();
            }, function (err) {
                _this.loading = false;
                _this.snackBarService.openSnackBar("Error retrieving user.");
            });
        });
    };
    UserDetailComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    Object.defineProperty(UserDetailComponent.prototype, "temporaryPasswordFC", {
        get: function () { return this.userForm.get("temporaryPassword"); },
        enumerable: true,
        configurable: true
    });
    UserDetailComponent.prototype.actionsDisabled = function () {
        return this.showLoadingSpinner()
            || this.showSaveSpinner();
    };
    UserDetailComponent.prototype.goToUsersList = function () {
        this.router.navigate(["/users"]);
    };
    UserDetailComponent.prototype.prepareSaveUser = function () {
        var formModel = this.userForm.value;
        // note - username field will be disabled, currently ignored by the backend anyway
        var username = this.userForm.get("username").value;
        var saveUser = {
            id: this.user.id,
            username: username,
            nameTitleCode: formModel.nameTitleCode,
            firstName: formModel.firstName,
            middleName: formModel.middleName,
            lastName: formModel.lastName,
            emailAddress: formModel.emailAddress,
            phoneNumber: formModel.phoneNumber,
            mobileNumber: formModel.mobileNumber,
            jobTitle: formModel.jobTitle,
            isWebAdmin: formModel.isWebAdmin,
            isActive: formModel.isActive,
            isLocked: formModel.isLocked,
        };
        return saveUser;
    };
    UserDetailComponent.prototype.resetPassword = function () {
        var _this = this;
        var dialogRef = this.dialog.open(confirm_dialog_component_1.ConfirmDialogComponent);
        dialogRef.componentInstance.question = "Reset password?";
        dialogRef.componentInstance.confirmButtonLabel = "RESET";
        dialogRef.afterClosed().subscribe(function (userConfirmed) {
            if (userConfirmed) {
                _this.loadingSave = true;
                _this.userService.resetPassword(_this.user.id)
                    .then(function (res) {
                    _this.loadingSave = false;
                    _this.temporaryPasswordFC.setValue(res.temporaryPassword);
                    _this.temporaryPasswordFC.disable();
                    _this.snackBarService.openSnackBar("Password has been reset.");
                })
                    .catch(function (err) {
                    _this.loadingSave = false;
                    _this.snackBarService.openSnackBar(err);
                });
            }
        });
    };
    UserDetailComponent.prototype.save = function () {
        var _this = this;
        if (this.userForm.invalid) {
            this.validationHelperService.markAllTouched(this.userForm);
            this.snackBarService.openSnackBar("Please fill in required values.");
            return;
        }
        this.loadingSave = true;
        var userToSave = this.prepareSaveUser();
        this.userService.update(userToSave)
            .then(function () {
            _this.loadingSave = false;
            _this.snackBarService.openSnackBar("User updated.");
            _this.goToUsersList();
        })
            .catch(function (err) {
            _this.loadingSave = false;
            _this.snackBarService.openSnackBar(err);
        });
    };
    UserDetailComponent.prototype.showLoadingSpinner = function () {
        return this.loading;
    };
    UserDetailComponent.prototype.showSaveSpinner = function () {
        return this.loadingSave;
    };
    UserDetailComponent.prototype.showTemporaryPassword = function () {
        return this.temporaryPasswordFC.value;
    };
    UserDetailComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(622),
            styles: [__webpack_require__(623)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute,
            material_1.MatDialog,
            forms_1.FormBuilder,
            user_service_1.UserService,
            router_1.Router,
            snack_bar_service_1.SnackBarService,
            validation_helper_service_1.ValidationHelperService])
    ], UserDetailComponent);
    return UserDetailComponent;
}());
exports.UserDetailComponent = UserDetailComponent;


/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var material_1 = __webpack_require__(29);
var ConfirmDialogComponent = /** @class */ (function () {
    function ConfirmDialogComponent(dialogRef) {
        this.dialogRef = dialogRef;
    }
    ConfirmDialogComponent.prototype.ngOnInit = function () {
        this.confirmButtonLabel = this.confirmButtonLabel || "CONFIRM";
        this.cancelButtonLabel = this.cancelButtonLabel || "CANCEL";
    };
    ConfirmDialogComponent.prototype.actionConfirmed = function () {
        this.dialogRef.close(true);
    };
    ConfirmDialogComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(621),
        }),
        __metadata("design:paramtypes", [material_1.MatDialogRef])
    ], ConfirmDialogComponent);
    return ConfirmDialogComponent;
}());
exports.ConfirmDialogComponent = ConfirmDialogComponent;


/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var forms_1 = __webpack_require__(17);
var material_1 = __webpack_require__(29);
var router_1 = __webpack_require__(26);
var rxjs_1 = __webpack_require__(4);
var operators_1 = __webpack_require__(6);
var user_service_1 = __webpack_require__(178);
var snack_bar_service_1 = __webpack_require__(44);
var UserListComponent = /** @class */ (function () {
    function UserListComponent(userService, router, snackBarService) {
        this.userService = userService;
        this.router = router;
        this.snackBarService = snackBarService;
        this.displayedColumns = ["username", "fullName", "isWebAdmin", "isActive", "isLocked", "actions"];
        this.ngUnsubscribe = new rxjs_1.Subject(); //see https://stackoverflow.com/a/41177163
        this.filterFC = new forms_1.FormControl();
        this.userDataSource = new material_1.MatTableDataSource();
    }
    UserListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.filterFC.valueChanges
            .pipe(operators_1.takeUntil(this.ngUnsubscribe))
            .subscribe(function (val) {
            _this.userDataSource.filter = val;
        });
        this.loading = true;
        this.userService.getListing()
            .then(function (data) {
            _this.loading = false;
            _this.userDataSource.data = data;
        })
            .catch(function (err) {
            _this.loading = false;
            _this.snackBarService.openSnackBar(err);
        });
    };
    UserListComponent.prototype.ngAfterViewInit = function () {
        this.userDataSource.sort = this.sort;
        this.userDataSource.paginator = this.paginator;
    };
    UserListComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    UserListComponent.prototype.goToUser = function (userID) {
        this.router.navigate(["/users", userID]);
    };
    __decorate([
        core_1.ViewChild(material_1.MatPaginator),
        __metadata("design:type", material_1.MatPaginator)
    ], UserListComponent.prototype, "paginator", void 0);
    __decorate([
        core_1.ViewChild(material_1.MatSort),
        __metadata("design:type", material_1.MatSort)
    ], UserListComponent.prototype, "sort", void 0);
    UserListComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(624),
            styles: [__webpack_require__(625)]
        }),
        __metadata("design:paramtypes", [user_service_1.UserService,
            router_1.Router,
            snack_bar_service_1.SnackBarService])
    ], UserListComponent);
    return UserListComponent;
}());
exports.UserListComponent = UserListComponent;


/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var router_1 = __webpack_require__(26);
var forms_1 = __webpack_require__(17);
var material_1 = __webpack_require__(29);
var auth_service_1 = __webpack_require__(85);
var perspective_service_1 = __webpack_require__(87);
var snack_bar_service_1 = __webpack_require__(44);
var change_password_dialog_component_1 = __webpack_require__(179);
var role_const_1 = __webpack_require__(177);
var app_version_1 = __webpack_require__(277);
var LoginComponent = /** @class */ (function () {
    function LoginComponent(dialog, fb, authService, perspectiveService, snackBarService, activatedRoute, router, role) {
        this.dialog = dialog;
        this.fb = fb;
        this.authService = authService;
        this.perspectiveService = perspectiveService;
        this.snackBarService = snackBarService;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.role = role;
        this.appVersion = app_version_1.appVersion.Version;
        this.releaseDate = app_version_1.appVersion.ReleaseDate;
        this.loginForm = this.fb.group({
            username: ['', [forms_1.Validators.required, forms_1.Validators.maxLength(100)]],
            password: ['', [forms_1.Validators.required, forms_1.Validators.maxLength(100)]],
        });
    }
    LoginComponent.prototype.ngOnInit = function () {
        // todo: fix this.. authService.logout causes 'expression changed after check' error with the toolbar? 
        // also cant seem to read the query param if it's set from the unauth interceptor?
        //this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
        //    if (params.get("unauthRedirect")) {
        //        //this.snackBarService.openSnackBar("Unauthorized - please login.");
        //        //this.authService.logout();
        //    }
        //});
    };
    LoginComponent.prototype.changePassword = function (role) {
        var _this = this;
        var dialogRef = this.dialog.open(change_password_dialog_component_1.ChangePasswordDialogComponent, {
            disableClose: true,
            data: {
                // todo: when password change is required, user can just login then refresh the browser to skip updating it
                passwordChangeMandatory: true
            }
        });
        dialogRef.afterClosed().subscribe(function () {
            _this.redirect(role);
        });
    };
    LoginComponent.prototype.onSubmit = function () {
        var _this = this;
        if (this.loginForm.valid) {
            this.loading = true;
            var creds = this.loginForm.value;
            this.authService.login(creds).subscribe(function (profile) {
                if (_this.authService.loggedIn()) {
                    if (profile.isRefreshPassword) {
                        _this.changePassword(profile.role);
                    }
                    else {
                        _this.redirect(profile.role);
                    }
                }
            }, function (error) {
                _this.loading = false;
                _this.message = error;
            });
        }
        else {
            this.message = "Username and password are required.";
        }
    };
    LoginComponent.prototype.redirect = function (role) {
        var redirect = this.authService.redirectUrl ? this.authService.redirectUrl : "/enquiries/new";
        // skip the perspective selection if one was already set in localStorage
        if (role === this.role.internalStaff && !this.perspectiveService.activeIntroducer) {
            redirect = "/perspective";
        }
        this.router.navigate([redirect]);
    };
    LoginComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(630),
            styles: [__webpack_require__(632)]
        }),
        __param(7, core_1.Inject(role_const_1.role)),
        __metadata("design:paramtypes", [material_1.MatDialog,
            forms_1.FormBuilder,
            auth_service_1.AuthService,
            perspective_service_1.PerspectiveService,
            snack_bar_service_1.SnackBarService,
            router_1.ActivatedRoute,
            router_1.Router, Object])
    ], LoginComponent);
    return LoginComponent;
}());
exports.LoginComponent = LoginComponent;


/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.appVersion = {
    Version: "1.0.7",
    ReleaseDate: "20181120"
};


/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var forms_1 = __webpack_require__(17);
var router_1 = __webpack_require__(26);
var material_1 = __webpack_require__(29);
var rxjs_1 = __webpack_require__(4);
var operators_1 = __webpack_require__(6);
var perspective_service_1 = __webpack_require__(87);
var snack_bar_service_1 = __webpack_require__(44);
var introducer_search_service_1 = __webpack_require__(279);
var theme_service_1 = __webpack_require__(107);
var PerspectiveComponent = /** @class */ (function () {
    function PerspectiveComponent(perspectiveService, introducerSearchService, router, snackBarService, themeService) {
        var _this = this;
        this.perspectiveService = perspectiveService;
        this.introducerSearchService = introducerSearchService;
        this.router = router;
        this.snackBarService = snackBarService;
        this.themeService = themeService;
        this.searchFC = new forms_1.FormControl();
        this.filteredIntroducers$ = this.searchFC.valueChanges
            .pipe(operators_1.debounceTime(300), operators_1.distinctUntilChanged(), operators_1.switchMap(function (term) {
            _this.loading = true;
            return term
                ? _this.introducerSearchService.search(term)
                : rxjs_1.of([]);
        }), operators_1.catchError(function (error) {
            // TODO: add real error handling
            console.log(error);
            return rxjs_1.of([]);
        }), operators_1.tap(function () { _this.loading = false; }));
    }
    PerspectiveComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // probably shouldnt need this setTimeout?
        // https://github.com/angular/material2/issues/1474#issuecomment-293683513
        setTimeout(function () {
            _this.searchInput.focus();
        });
    };
    PerspectiveComponent.prototype.setPerspective = function (e) {
        var _this = this;
        this.perspectiveService.activeIntroducer = e.option.value;
        this.themeService.getTheme()
            .catch(function (err) { return _this.snackBarService.openSnackBar("Error retrieving theme settings."); });
        this.router.navigate(["/enquiries/new"]);
    };
    __decorate([
        core_1.ViewChild(material_1.MatInput),
        __metadata("design:type", material_1.MatInput)
    ], PerspectiveComponent.prototype, "searchInput", void 0);
    PerspectiveComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(633),
        }),
        __metadata("design:paramtypes", [perspective_service_1.PerspectiveService,
            introducer_search_service_1.IntroducerSearchService,
            router_1.Router,
            snack_bar_service_1.SnackBarService,
            theme_service_1.ThemeService])
    ], PerspectiveComponent);
    return PerspectiveComponent;
}());
exports.PerspectiveComponent = PerspectiveComponent;


/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var http_1 = __webpack_require__(33);
var IntroducerSearchService = /** @class */ (function () {
    function IntroducerSearchService(http) {
        this.http = http;
    }
    IntroducerSearchService.prototype.search = function (term) {
        return this.http.get("api/profile/introducers/?name=" + term);
    };
    IntroducerSearchService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient])
    ], IntroducerSearchService);
    return IntroducerSearchService;
}());
exports.IntroducerSearchService = IntroducerSearchService;


/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var common_1 = __webpack_require__(3);
var forms_1 = __webpack_require__(17);
var material_1 = __webpack_require__(29);
var router_1 = __webpack_require__(26);
var rxjs_1 = __webpack_require__(4);
var operators_1 = __webpack_require__(6);
var enquiry_service_1 = __webpack_require__(180);
var snack_bar_service_1 = __webpack_require__(44);
var validation_helper_service_1 = __webpack_require__(108);
var at_least_one_validator_1 = __webpack_require__(640);
var download_quote_dialog_component_1 = __webpack_require__(281);
var email_enquiry_dialog_component_1 = __webpack_require__(282);
var EnquiryDetailComponent = /** @class */ (function () {
    function EnquiryDetailComponent(dialog, enquiryService, fb, activatedRoute, router, location, snackBarService, validationHelperService) {
        this.dialog = dialog;
        this.enquiryService = enquiryService;
        this.fb = fb;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.location = location;
        this.snackBarService = snackBarService;
        this.validationHelperService = validationHelperService;
        this.currencyInputRegex = /^[1-9]\d*(\.\d+)?$/; // Temp (until we can use number input instead of text) currency input (no leading zeroes). Use this - https://regexr.com/
        this.ngUnsubscribe = new rxjs_1.Subject(); //see https://stackoverflow.com/a/41177163
        // using BehaviorSubject since we need to be able to push the current repaymentOpts into the email/download quote dialogs when they are opened.
        // see section on BehaviorSubject - http://blog.angular-university.io/how-to-build-angular2-apps-using-rxjs-observable-data-services-pitfalls-to-avoid/
        this._repaymentOptions$ = new rxjs_1.BehaviorSubject([]);
        this.repaymentOptions$ = this._repaymentOptions$.asObservable();
        this.programFilterFC = new forms_1.FormControl();
        this.repaymentOptionFC = new forms_1.FormControl();
        this.createForm();
    }
    Object.defineProperty(EnquiryDetailComponent.prototype, "content", {
        set: function (content) {
            this.frequencyTabGroup = content;
        },
        enumerable: true,
        configurable: true
    });
    EnquiryDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadingEnquiryOptions = true;
        // get the enquiryOptions, and then the existing enquiry (or a default one if new)
        this.enquiryService.getOptions()
            .then(function (data) {
            _this.opts = data;
            if (_this.opts.introducerRateCharts.length === 0) {
                throw new Error("No finance types have been made available to this supplier - enquiries cannot be created.");
            }
            _this.uniquePrograms = Array.from(// make an array of DropdownOption from this.introducerRateCharts
            new Set(_this.opts.introducerRateCharts
                .map(function (irc) {
                return {
                    id: irc.programID,
                    label: irc.programName,
                };
            })
                .filter(function (opt, index, self) {
                return index === self.findIndex(function (o) { return (o.id === opt.id); });
            })
                .sort(function (a, b) { return a.label.localeCompare(b.label); }) // es6 sort https://stackoverflow.com/a/35092754
            ));
            _this.activatedRoute.paramMap
                .pipe(operators_1.takeUntil(_this.ngUnsubscribe), operators_1.switchMap(function (params) { return _this.enquiryService.getEnquiry(+params.get("id")); }) // (+) converts string "id" to a number
            )
                .subscribe(function (enq) {
                _this.loadingEnquiryOptions = false;
                _this.enquiry = enq;
                _this.enquiryForm.patchValue(_this.enquiry);
                _this.financeFG.patchValue(_this.enquiry);
                _this.phoneNumbersFG.get("phone").setValue(_this.enquiry.phoneNumber);
                _this.phoneNumbersFG.get("mobile").setValue(_this.enquiry.mobileNumber);
                // The vendor program filter dropdown doesn't actually get saved with the rest of the form,
                // it's just a presentation component that filters the "Finance Type" (introducerRateChartID) dropdown for the user.
                // Having to split this into two dropdowns (Vendor Program / Finance Type), even though its just a single object (IntroducerRateChart)
                // has resulted in a bit of extra logic, but FAW have asked for it this way as it may be easier for the user.
                var savedIrc = _this.opts.introducerRateCharts.find(function (irc) { return irc.id === _this.enquiry.introducerRateChartID; });
                var firstIrcUsingDefaultProduct = _this.opts.introducerRateCharts.filter(function (i) { return i.productID === _this.opts.defaultProductID; })[0];
                var programID;
                if (savedIrc) {
                    programID = savedIrc.programID;
                }
                else if (firstIrcUsingDefaultProduct) {
                    programID = firstIrcUsingDefaultProduct.programID;
                }
                else {
                    programID = _this.uniquePrograms[0].id;
                }
                _this.updateFilteredIrcs(programID);
                _this.programFilterFC.setValue(programID, { emitEvent: false });
                if (!_this.enquiry.id && _this.filteredIrcs.length > 0) {
                    _this.financeFG.get("introducerRateChartID").setValue(_this.filteredIrcs[0].id);
                }
                if (_this.enquiry.submittedOn != null) {
                    _this.programFilterFC.disable({ emitEvent: false });
                    _this.enquiryForm.disable({ emitEvent: false });
                }
            }, function (err) { return _this.snackBarService.openSnackBar("Error retrieving enquiry."); });
        })
            .catch(function (err) {
            _this.loadingEnquiryOptions = false;
            _this.errorMessage = err;
        });
        // when a vendor program is selected, filter the introducerRateChartID dropdown and select the first one
        this.programFilterFC.valueChanges
            .pipe(operators_1.takeUntil(this.ngUnsubscribe))
            .subscribe(function (val) {
            _this.updateFilteredIrcs(val);
            _this.financeFG.get("introducerRateChartID").setValue(_this.filteredIrcs[0].id);
        });
        // update form validators and assetTypeGroup dropdown when the introducerRateChart dropdown changes
        this.financeFG.get("introducerRateChartID").valueChanges
            .pipe(operators_1.takeUntil(this.ngUnsubscribe))
            .subscribe(function (val) {
            _this.selectedIrc = _this.opts.introducerRateCharts.find(function (i) { return i.id === val; });
            if (_this.selectedIrc && _this.checkSelectedIrcConfig()) {
                var assetTypeGroupFC_1 = _this.financeFG.get("assetTypeGroupID");
                if (!_this.selectedIrc.assetTypeGroups.find(function (a) { return a.id === assetTypeGroupFC_1.value; })) {
                    assetTypeGroupFC_1.setValue(_this.selectedIrc.assetTypeGroups[0].id);
                }
                _this.costOfGoodsFC.setValidators([
                    forms_1.Validators.required,
                    forms_1.Validators.pattern(_this.currencyInputRegex),
                    forms_1.Validators.min(_this.selectedIrc.minCostOfGoods),
                    forms_1.Validators.max(_this.selectedIrc.maxCostOfGoods)
                ]);
                _this.costOfGoodsFC.updateValueAndValidity();
                var isAdvanceFC = _this.financeFG.get("isAdvance");
                isAdvanceFC.setValue(_this.selectedIrc.allowInAdvance);
                (_this.selectedIrc.allowInAdvance && _this.selectedIrc.allowInArrears)
                    ? isAdvanceFC.enable()
                    : isAdvanceFC.disable();
            }
        });
        // automatically get repayment options when the finance area of the form is valid
        this.financeFG.valueChanges
            .pipe(operators_1.takeUntil(this.ngUnsubscribe), operators_1.debounceTime(500), //TODO: debounce also happens on initial load when opening an existing enquiry..
        operators_1.distinctUntilChanged(), //TODO: doesnt do anything?
        operators_1.switchMap(function (val) {
            _this.repaymentOptionFC.reset();
            if (_this.financeFG.valid) {
                _this.loadingRepaymentOptions = true;
                return _this.getRepaymentOptions();
            }
            else {
                return rxjs_1.of([]);
            }
        }), operators_1.tap(function (opts) {
            _this.loadingRepaymentOptions = false;
            _this._repaymentOptions$.next(opts);
            // if opening an existing enquiry, search for a matching repayment option and 'select' it
            var selectedOpt = opts.find(function (r) {
                return r.paymentFrequencyID === _this.enquiry.paymentFrequencyID
                    && r.repayment === _this.enquiry.repayment
                    && r.term === _this.enquiry.term
                    && r.residualAmount === _this.enquiry.residualAmount;
            });
            if (selectedOpt) {
                _this.repaymentOptionFC.setValue(selectedOpt);
                // ensure the correct payment frequency tab is active on load
                if (_this.frequencyTabGroup) {
                    _this.frequencyTabGroup.selectedIndex = _this.selectedIrc.paymentFrequencies.findIndex(function (f) { return f.id == selectedOpt.paymentFrequencyID; });
                }
            }
        }), operators_1.catchError(function (err) {
            _this.errorMessage = err;
            return rxjs_1.of([]);
        }))
            .subscribe();
    };
    EnquiryDetailComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    EnquiryDetailComponent.prototype.actionsDisabled = function () {
        if (this.enquiry) {
            return (this.enquiry.submittedOn != null)
                || this.loadingEnquiryOptions
                || this.showRepaymentsSpinner()
                || this.showSavingSpinner()
                || this.showSubmissionSpinner()
                || this.errorMessage != null;
        }
        else {
            return true;
        }
    };
    Object.defineProperty(EnquiryDetailComponent.prototype, "costOfGoodsFC", {
        get: function () { return this.enquiryForm.get("finance.costOfGoods"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnquiryDetailComponent.prototype, "financeFG", {
        get: function () { return this.enquiryForm.get("finance"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnquiryDetailComponent.prototype, "phoneNumbersFG", {
        get: function () { return this.enquiryForm.get("phoneNumbers"); },
        enumerable: true,
        configurable: true
    });
    EnquiryDetailComponent.prototype.checkSelectedIrcConfig = function () {
        var isValid = this.selectedIrc.terms != null
            && this.selectedIrc.terms.length > 0
            && this.selectedIrc.paymentFrequencies != null
            && this.selectedIrc.paymentFrequencies.length > 0
            && this.selectedIrc.assetTypeGroups != null
            && this.selectedIrc.assetTypeGroups.length > 0;
        this.errorMessage = isValid ? null : "Rates configuration error.";
        return isValid;
    };
    EnquiryDetailComponent.prototype.createForm = function () {
        this.enquiryForm = this.fb.group({
            // separate 'finance' formGroup so we can just validate this before getting repayment options
            finance: this.fb.group({
                introducerRateChartID: ['', forms_1.Validators.required],
                assetTypeGroupID: ['', forms_1.Validators.required],
                costOfGoods: ['', [forms_1.Validators.required, forms_1.Validators.pattern(this.currencyInputRegex)]],
                isAdvance: ['', forms_1.Validators.required],
            }),
            phoneNumbers: this.fb.group({
                phone: ['', forms_1.Validators.maxLength(20)],
                mobile: ['', forms_1.Validators.maxLength(20)],
            }, { validator: at_least_one_validator_1.atLeastOne(forms_1.Validators.required) }),
            goodsDescription: ['', forms_1.Validators.maxLength(1000)],
            contactName: ['', [forms_1.Validators.required, forms_1.Validators.maxLength(100)]],
            businessName: ['', [forms_1.Validators.required, forms_1.Validators.maxLength(100)]],
            abn: ['', [forms_1.Validators.minLength(11), forms_1.Validators.maxLength(11)]],
            emailAddress: ['', forms_1.Validators.maxLength(100)],
            address: ['', forms_1.Validators.maxLength(200)],
            notes: ['', forms_1.Validators.maxLength(500)],
        });
    };
    EnquiryDetailComponent.prototype.getFilteredRepaymentOptions = function (paymentFrequencyID, opts) {
        return opts.filter(function (r) { return r.paymentFrequencyID == paymentFrequencyID; });
    };
    EnquiryDetailComponent.prototype.getRepaymentOptions = function () {
        var calcParams = {
            introducerRateChartID: this.financeFG.get("introducerRateChartID").value,
            assetTypeGroupID: this.financeFG.get("assetTypeGroupID").value,
            costOfGoods: this.financeFG.get("costOfGoods").value,
            isAdvance: this.financeFG.get("isAdvance").value
        };
        return this.enquiryService.getRepaymentOptions(calcParams);
    };
    EnquiryDetailComponent.prototype.getResidualLabel = function () {
        return (this.selectedIrc && this.selectedIrc.labelResidualAsBalloon)
            ? "Balloon"
            : "Residual";
    };
    EnquiryDetailComponent.prototype.getSelectedRepaymentOptionIndex = function (opts) {
        var selectedOptIndex = null;
        var selectedOpt = this.repaymentOptionFC.value;
        if (selectedOpt) {
            selectedOptIndex = opts.findIndex(function (r) {
                return r.paymentFrequencyID === selectedOpt.paymentFrequencyID
                    && r.repayment === selectedOpt.repayment
                    && r.term === selectedOpt.term
                    && r.residualAmount === selectedOpt.residualAmount;
            });
        }
        return selectedOptIndex;
    };
    EnquiryDetailComponent.prototype.getSingularFrequencyDesc = function (paymentFreq) {
        var singularDesc = null;
        switch (paymentFreq) {
            case 'Weekly':
                singularDesc = 'Week';
                break;
            case 'Monthly':
                singularDesc = 'Month';
                break;
            case 'Quarterly':
                singularDesc = 'Quarter';
                break;
            case 'Annual':
                singularDesc = 'Year';
                break;
            case 'Fortnightly':
                singularDesc = 'Fortnight';
                break;
            default:
                singularDesc = 'Period';
                break;
        }
        return singularDesc;
    };
    EnquiryDetailComponent.prototype.goToEnquiriesList = function () {
        this.router.navigate(["/enquiries"]);
    };
    EnquiryDetailComponent.prototype.isRepaymentOptionSelected = function (opt) {
        var isSelected = false;
        var selectedOpt = this.repaymentOptionFC.value;
        if (selectedOpt) {
            isSelected =
                opt.paymentFrequencyID === selectedOpt.paymentFrequencyID
                    && opt.repayment === selectedOpt.repayment
                    && opt.term === selectedOpt.term
                    && opt.residualAmount === selectedOpt.residualAmount;
        }
        return isSelected;
    };
    EnquiryDetailComponent.prototype.openDownloadQuoteDialog = function () {
        var opts = this._repaymentOptions$.getValue();
        var selectedOptIndex = this.getSelectedRepaymentOptionIndex(opts);
        var dialogRef = this.dialog.open(download_quote_dialog_component_1.DownloadQuoteDialogComponent, {
            data: {
                enquiryID: this.enquiry.id,
                repaymentOptions: opts,
                selectedRepaymentIndex: selectedOptIndex
            }
        });
    };
    EnquiryDetailComponent.prototype.openEmailEnquiryDialog = function () {
        var opts = this._repaymentOptions$.getValue();
        var selectedOptIndex = this.getSelectedRepaymentOptionIndex(opts);
        var dialogRef = this.dialog.open(email_enquiry_dialog_component_1.EmailEnquiryDialogComponent, {
            //height: '80%',
            //width: '80%',
            disableClose: true,
            autoFocus: false,
            data: {
                applicationFormAvailable: this.selectedIrc.applicationFormAvailable,
                enquiry: this.enquiry,
                repaymentOptions: opts,
                selectedRepaymentIndex: selectedOptIndex
            }
        });
    };
    // see https://angular.io/guide/reactive-forms#save-form-data
    EnquiryDetailComponent.prototype.prepareSaveEnquiry = function () {
        var formModel = this.enquiryForm.value;
        var isAdvance = this.financeFG.get("isAdvance").value; // because the FormControl may be disabled
        var selectedOpt = this.repaymentOptionFC.value;
        // assigning a few extra fields here just so we don't need to look up the ID values again on the backend, before sending the email
        var assetTypeGroup = this.selectedIrc.assetTypeGroups.find(function (i) { return i.id === formModel.finance.assetTypeGroupID; });
        var saveEnquiry = {
            id: this.enquiry.id,
            enquiryNumber: "",
            // from formModel.finance
            introducerRateChartID: formModel.finance.introducerRateChartID,
            productName: this.selectedIrc.productName,
            programName: this.selectedIrc.programName,
            assetTypeGroupID: formModel.finance.assetTypeGroupID,
            assetTypeGroupName: assetTypeGroup.label,
            costOfGoods: formModel.finance.costOfGoods,
            isAdvance: isAdvance,
            // from formModel.phoneNumbers
            phoneNumber: formModel.phoneNumbers.phone,
            mobileNumber: formModel.phoneNumbers.mobile,
            // from formModel
            goodsDescription: formModel.goodsDescription,
            contactName: formModel.contactName,
            businessName: formModel.businessName,
            abn: formModel.abn,
            emailAddress: formModel.emailAddress,
            address: formModel.address,
            notes: formModel.notes,
            // from selected RepaymentOption
            paymentFrequencyID: selectedOpt ? selectedOpt.paymentFrequencyID : null,
            paymentFrequencyName: selectedOpt ? selectedOpt.paymentFrequencyName : null,
            repayment: selectedOpt ? selectedOpt.repayment : null,
            term: selectedOpt ? selectedOpt.term : null,
            residualAmount: selectedOpt ? selectedOpt.residualAmount : null,
        };
        return saveEnquiry;
    };
    EnquiryDetailComponent.prototype.save = function (downloadQuoteClicked, emailClicked) {
        var _this = this;
        if (this.enquiryForm.invalid) {
            this.validationHelperService.markAllTouched(this.enquiryForm);
            this.snackBarService.openSnackBar("Please fill in required values.");
            return;
        }
        this.loadingSave = true;
        var enquiryToSave = this.prepareSaveEnquiry();
        if (enquiryToSave.id != null) {
            this.enquiryService.update(enquiryToSave)
                .then(function () {
                _this.loadingSave = false;
                _this.enquiry = Object.assign({}, enquiryToSave);
                _this.snackBarService.openSnackBar("Enquiry updated.");
                // TODO: this could be implemented better..
                if (downloadQuoteClicked) {
                    _this.openDownloadQuoteDialog();
                }
                else if (emailClicked) {
                    _this.openEmailEnquiryDialog();
                }
            })
                .catch(function (err) {
                _this.loadingSave = false;
                _this.snackBarService.openSnackBar(err);
            });
        }
        else {
            this.enquiryService.create(enquiryToSave)
                .then(function (enq) {
                _this.loadingSave = false;
                _this.enquiry = Object.assign({}, enquiryToSave);
                _this.enquiry.id = enq.id;
                _this.snackBarService.openSnackBar("Enquiry saved.");
                // Replace "/new" in the URL with "/{id}"
                // This was added because of the default behaviour in iOS Safari when downloading a PDF from the email/quote dialogs.
                // Safari will open the PDF in the current tab, and then the user would need to click the back button on their phone, so
                // we'd need the ID in the URL to ensure the enquiry data is reloaded when they navigate back.
                _this.location.replaceState("/enquiries/" + _this.enquiry.id);
                if (downloadQuoteClicked) {
                    _this.openDownloadQuoteDialog();
                }
                else if (emailClicked) {
                    _this.openEmailEnquiryDialog();
                }
            })
                .catch(function (err) {
                _this.loadingSave = false;
                _this.snackBarService.openSnackBar(err);
            });
        }
    };
    EnquiryDetailComponent.prototype.showAssetTypeGroup = function () {
        return this.selectedIrc && this.selectedIrc.assetTypeGroups.length > 1;
    };
    EnquiryDetailComponent.prototype.showFinanceForm = function () {
        return this.enquiry != null && this.opts != null;
    };
    EnquiryDetailComponent.prototype.showFinanceInvalidMessage = function () {
        return this.financeFG.invalid;
    };
    EnquiryDetailComponent.prototype.showPhoneError = function () {
        return this.phoneNumbersFG.touched && this.phoneNumbersFG.hasError("atLeastOne");
    };
    EnquiryDetailComponent.prototype.showProgramFilter = function () {
        return this.uniquePrograms && this.uniquePrograms.length > 1;
    };
    EnquiryDetailComponent.prototype.showRepaymentsList = function () {
        return !this.loadingRepaymentOptions && this.financeFG.valid;
    };
    EnquiryDetailComponent.prototype.showRepaymentsSpinner = function () {
        return this.loadingRepaymentOptions && this.financeFG.valid;
    };
    EnquiryDetailComponent.prototype.showResidual = function () {
        return this.selectedIrc && this.selectedIrc.showResidualValue;
    };
    EnquiryDetailComponent.prototype.showSavingSpinner = function () {
        return this.loadingSave;
    };
    EnquiryDetailComponent.prototype.showSubmissionSpinner = function () {
        return this.loadingSubmission;
    };
    EnquiryDetailComponent.prototype.showSubmittedRepaymentOption = function () {
        return this.enquiry && (this.enquiry.submittedOn != null);
    };
    EnquiryDetailComponent.prototype.submit = function () {
        var _this = this;
        if (this.enquiryForm.invalid || !this.repaymentOptionFC.value) {
            this.validationHelperService.markAllTouched(this.enquiryForm);
            this.snackBarService.openSnackBar("Please fill in required values and select a repayment option.");
            return;
        }
        this.loadingSubmission = true;
        var enquiryToSave = this.prepareSaveEnquiry();
        this.enquiryService.submit(enquiryToSave)
            .then(function () {
            _this.loadingSubmission = false;
            _this.snackBarService.openSnackBar("Enquiry submitted.");
            _this.goToEnquiriesList();
        })
            .catch(function (err) {
            _this.loadingSubmission = false;
            _this.snackBarService.openSnackBar(err);
        });
    };
    EnquiryDetailComponent.prototype.updateFilteredIrcs = function (programID) {
        var _this = this;
        this.filteredIrcs = this.opts.introducerRateCharts.filter(function (irc) { return irc.programID == programID; });
        // FAW always want the default product (currently Operating Lease) to appear at the top of the dropdown
        var index = this.filteredIrcs.findIndex(function (i) { return i.productID === _this.opts.defaultProductID; });
        if (index > -1) {
            var defaultProductIrc = this.filteredIrcs.splice(index, 1)[0];
            this.filteredIrcs.unshift(defaultProductIrc);
        }
    };
    __decorate([
        core_1.ViewChild(material_1.MatTabGroup),
        __metadata("design:type", material_1.MatTabGroup),
        __metadata("design:paramtypes", [material_1.MatTabGroup])
    ], EnquiryDetailComponent.prototype, "content", null);
    EnquiryDetailComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(645),
            styles: [__webpack_require__(646)]
        }),
        __metadata("design:paramtypes", [material_1.MatDialog,
            enquiry_service_1.EnquiryService,
            forms_1.FormBuilder,
            router_1.ActivatedRoute,
            router_1.Router,
            common_1.Location,
            snack_bar_service_1.SnackBarService,
            validation_helper_service_1.ValidationHelperService])
    ], EnquiryDetailComponent);
    return EnquiryDetailComponent;
}());
exports.EnquiryDetailComponent = EnquiryDetailComponent;


/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var forms_1 = __webpack_require__(17);
var material_1 = __webpack_require__(29);
var FileSaver = __webpack_require__(176);
var document_service_1 = __webpack_require__(181);
var snack_bar_service_1 = __webpack_require__(44);
var DownloadQuoteDialogComponent = /** @class */ (function () {
    function DownloadQuoteDialogComponent(documentService, fb, snackBarService, data, dialogRef) {
        this.documentService = documentService;
        this.fb = fb;
        this.snackBarService = snackBarService;
        this.data = data;
        this.dialogRef = dialogRef;
        this.downloadQuoteForm = this.fb.group({
            showAssetCost: [true, forms_1.Validators.required],
            repaymentOptionCheckboxes: this.fb.array([]),
        });
    }
    DownloadQuoteDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.enquiryID = this.data.enquiryID;
        this.repaymentOptions = this.data.repaymentOptions;
        var selectedRepaymentIndex = this.data.selectedRepaymentIndex;
        this.repaymentOptions.forEach(function (opt, index) {
            _this.repaymentCheckboxesFA.push(new forms_1.FormControl(index === selectedRepaymentIndex));
        });
    };
    Object.defineProperty(DownloadQuoteDialogComponent.prototype, "repaymentCheckboxesFA", {
        get: function () { return this.downloadQuoteForm.get("repaymentOptionCheckboxes"); },
        enumerable: true,
        configurable: true
    });
    DownloadQuoteDialogComponent.prototype.displayPaymentFrequency = function (index) {
        return (index == 0)
            || (this.repaymentOptions[index - 1].paymentFrequencyID != this.repaymentOptions[index].paymentFrequencyID);
    };
    DownloadQuoteDialogComponent.prototype.downloadQuote = function () {
        var _this = this;
        var checkboxValues = this.repaymentCheckboxesFA.value;
        if (!checkboxValues.some(function (checked) { return checked === true; })) {
            this.snackBarService.openSnackBar("Please select at least one repayment option.");
            return;
        }
        this.showSpinner = true;
        var showAssetCost = this.downloadQuoteForm.get('showAssetCost').value;
        var quoteDocGenData = this.documentService.prepareQuoteDocGenData(showAssetCost, checkboxValues, this.repaymentOptions);
        this.documentService.downloadQuotePdf(this.enquiryID, quoteDocGenData)
            .subscribe(function (res) {
            _this.showSpinner = false;
            var fileName = res.headers.get("Content-Disposition").match(/"(.*?)"/g).toString(); // get the string between the quotes, but includes the quotes
            fileName = fileName.replace(/["]+/g, ''); // remove the quotes
            FileSaver.saveAs(res.body, fileName);
        }, function (err) {
            _this.showSpinner = false;
            _this.snackBarService.openSnackBar(err);
        }, function () {
            _this.dialogRef.close();
        });
    };
    DownloadQuoteDialogComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(641),
            styles: [__webpack_require__(642)]
        }),
        __param(3, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [document_service_1.DocumentService,
            forms_1.FormBuilder,
            snack_bar_service_1.SnackBarService, Object, material_1.MatDialogRef])
    ], DownloadQuoteDialogComponent);
    return DownloadQuoteDialogComponent;
}());
exports.DownloadQuoteDialogComponent = DownloadQuoteDialogComponent;


/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var forms_1 = __webpack_require__(17);
var material_1 = __webpack_require__(29);
var FileSaver = __webpack_require__(176);
var auth_service_1 = __webpack_require__(85);
var email_service_1 = __webpack_require__(182);
var document_service_1 = __webpack_require__(181);
var snack_bar_service_1 = __webpack_require__(44);
var validation_helper_service_1 = __webpack_require__(108);
var EmailEnquiryDialogComponent = /** @class */ (function () {
    function EmailEnquiryDialogComponent(authService, documentService, emailService, fb, snackBarService, validationHelperService, data, dialogRef) {
        this.authService = authService;
        this.documentService = documentService;
        this.emailService = emailService;
        this.fb = fb;
        this.snackBarService = snackBarService;
        this.validationHelperService = validationHelperService;
        this.data = data;
        this.dialogRef = dialogRef;
        this.fileInputFC = new forms_1.FormControl();
        this.emailForm = this.fb.group({
            showAssetCost: [true, forms_1.Validators.required],
            repaymentOptionCheckboxes: this.fb.array([]),
            to: ['', [forms_1.Validators.required, forms_1.Validators.maxLength(300)]],
            cc: ['', forms_1.Validators.maxLength(300)],
            bcc: ['', forms_1.Validators.maxLength(300)],
            subject: ['Enquiry', forms_1.Validators.maxLength(300)],
            body: ['', forms_1.Validators.required],
            attachments: this.fb.array([])
        });
    }
    EmailEnquiryDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.applicationFormAvailable = this.data.applicationFormAvailable;
        this.enquiry = this.data.enquiry;
        this.repaymentOptions = this.data.repaymentOptions;
        var selectedRepaymentIndex = this.data.selectedRepaymentIndex;
        this.repaymentOptions.forEach(function (opt, index) {
            _this.repaymentCheckboxesFA.push(new forms_1.FormControl(index === selectedRepaymentIndex));
        });
        this.prefillEmail();
    };
    Object.defineProperty(EmailEnquiryDialogComponent.prototype, "repaymentCheckboxesFA", {
        get: function () { return this.emailForm.get("repaymentOptionCheckboxes"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmailEnquiryDialogComponent.prototype, "attachmentsFA", {
        get: function () { return this.emailForm.get("attachments"); },
        enumerable: true,
        configurable: true
    });
    EmailEnquiryDialogComponent.prototype.prefillEmail = function () {
        var profile = this.authService.userProfile;
        this.emailForm.get("to").setValue(this.enquiry.emailAddress);
        this.emailForm.get("bcc").setValue(profile.emailAddress);
        var signature = profile.fullName;
        if (profile.jobTitle) {
            signature = signature.concat("\n", profile.jobTitle);
        }
        if (profile.phoneNumber) {
            signature = signature.concat("\nPh. ", profile.phoneNumber);
        }
        if (profile.mobileNumber) {
            signature = signature.concat("\nMob. ", profile.mobileNumber);
        }
        if (profile.emailAddress) {
            signature = signature.concat("\n", profile.emailAddress);
        }
        var body = "Dear " + this.enquiry.contactName + ",\n\n\n\n" + signature;
        this.emailForm.get("body").setValue(body);
    };
    EmailEnquiryDialogComponent.prototype.displayPaymentFrequency = function (index) {
        return (index == 0)
            || (this.repaymentOptions[index - 1].paymentFrequencyID != this.repaymentOptions[index].paymentFrequencyID);
    };
    EmailEnquiryDialogComponent.prototype.downloadApplicationForm = function () {
        var _this = this;
        this.showSpinner = true;
        this.documentService.downloadApplicationForm(this.enquiry.id)
            .subscribe(function (res) {
            _this.showSpinner = false;
            var fileName = res.headers.get("Content-Disposition").match(/"(.*?)"/g).toString(); // get the string between the quotes, but includes the quotes
            fileName = fileName.replace(/["]+/g, ''); // remove the quotes
            FileSaver.saveAs(res.body, fileName);
        }, function (err) {
            _this.showSpinner = false;
            _this.snackBarService.openSnackBar(err);
        });
    };
    EmailEnquiryDialogComponent.prototype.downloadQuote = function () {
        var _this = this;
        var checkboxValues = this.repaymentCheckboxesFA.value;
        if (!checkboxValues.some(function (checked) { return checked === true; })) {
            this.snackBarService.openSnackBar("Please select at least one repayment option.");
            return;
        }
        this.showSpinner = true;
        var showAssetCost = this.emailForm.get('showAssetCost').value;
        var quoteDocGenData = this.documentService.prepareQuoteDocGenData(showAssetCost, checkboxValues, this.repaymentOptions);
        this.documentService.downloadQuotePdf(this.enquiry.id, quoteDocGenData)
            .subscribe(function (res) {
            _this.showSpinner = false;
            var fileName = res.headers.get("Content-Disposition").match(/"(.*?)"/g).toString(); // get the string between the quotes, but includes the quotes
            fileName = fileName.replace(/["]+/g, ''); // remove the quotes
            FileSaver.saveAs(res.body, fileName);
        }, function (err) {
            _this.showSpinner = false;
            _this.snackBarService.openSnackBar(err);
        });
    };
    // refer to docs for File obj structure https://developer.mozilla.org/en-US/docs/Web/API/File
    // code modified from https://nehalist.io/uploading-files-in-angular2/
    EmailEnquiryDialogComponent.prototype.onFileChange = function (event) {
        var _this = this;
        var reader = new FileReader();
        if (event.target.files && event.target.files.length > 0) {
            var file_1 = event.target.files[0];
            reader.readAsDataURL(file_1); // see https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
            reader.onload = function () {
                var attachmentFG = _this.fb.group({
                    fileName: file_1.name,
                    fileType: file_1.type,
                    // readAsDataURL() returns a string in the form "data:application/pdf;base64,JVBERi0x..."
                    fileContentBase64: reader.result.split(',')[1]
                });
                _this.attachmentsFA.push(attachmentFG);
                _this.fileInputFC.reset();
            };
        }
    };
    EmailEnquiryDialogComponent.prototype.prepareSendEmail = function () {
        var formModel = this.emailForm.value;
        var checkboxValues = this.repaymentCheckboxesFA.value;
        var showAssetCost = this.emailForm.get("showAssetCost").value;
        var docGenData = this.documentService.prepareQuoteDocGenData(showAssetCost, checkboxValues, this.repaymentOptions);
        // shallow copy.. deep copy shouldnt be necessary in this instance since attachment files aren't saved
        var attachFiles = this.attachmentsFA.value;
        var emailToSend = {
            quoteDocGenData: docGenData,
            to: formModel.to,
            cc: formModel.cc,
            bcc: formModel.bcc,
            subject: formModel.subject,
            body: formModel.body,
            attachments: attachFiles
        };
        return emailToSend;
    };
    EmailEnquiryDialogComponent.prototype.removeAttachment = function (index) {
        this.attachmentsFA.removeAt(index);
    };
    EmailEnquiryDialogComponent.prototype.sendEmail = function () {
        var _this = this;
        var checkboxValues = this.repaymentCheckboxesFA.value;
        if (!checkboxValues.some(function (checked) { return checked === true; }) || this.emailForm.invalid) {
            this.validationHelperService.markAllTouched(this.emailForm);
            this.snackBarService.openSnackBar("Please select at least one repayment option and fill in required values.");
            return;
        }
        this.showSpinner = true;
        var email = this.prepareSendEmail();
        this.emailService.sendEmail(this.enquiry.id, email)
            .then(function () {
            _this.showSpinner = false;
            _this.snackBarService.openSnackBar("Email sent.");
            _this.dialogRef.close();
        })
            .catch(function (err) {
            _this.showSpinner = false;
            _this.snackBarService.openSnackBar(err);
        });
    };
    EmailEnquiryDialogComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(643),
            styles: [__webpack_require__(644)]
        }),
        __param(6, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [auth_service_1.AuthService,
            document_service_1.DocumentService,
            email_service_1.EmailService,
            forms_1.FormBuilder,
            snack_bar_service_1.SnackBarService,
            validation_helper_service_1.ValidationHelperService, Object, material_1.MatDialogRef])
    ], EmailEnquiryDialogComponent);
    return EmailEnquiryDialogComponent;
}());
exports.EmailEnquiryDialogComponent = EmailEnquiryDialogComponent;


/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var forms_1 = __webpack_require__(17);
var material_1 = __webpack_require__(29);
var router_1 = __webpack_require__(26);
var rxjs_1 = __webpack_require__(4);
var operators_1 = __webpack_require__(6);
var enquiry_service_1 = __webpack_require__(180);
var snack_bar_service_1 = __webpack_require__(44);
var email_history_dialog_component_1 = __webpack_require__(284);
var EnquiryListComponent = /** @class */ (function () {
    function EnquiryListComponent(activatedRoute, dialog, enquiryService, router, snackBarService) {
        this.activatedRoute = activatedRoute;
        this.dialog = dialog;
        this.enquiryService = enquiryService;
        this.router = router;
        this.snackBarService = snackBarService;
        this.displayedColumns = ["enquiryNumber", "businessName", "contactName", "product", "costOfGoods",
            "term", "repayment", "createdOn", "lastEmailSentOn", "submittedOn", "actions"];
        this.ngUnsubscribe = new rxjs_1.Subject(); //see https://stackoverflow.com/a/41177163
        this.monthsAgoFC = new forms_1.FormControl();
        this.filterFC = new forms_1.FormControl();
        this.monthOptions = [1, 3, 6, 12];
        this.dataSource = new material_1.MatTableDataSource();
    }
    EnquiryListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.monthsAgoFC.valueChanges
            .pipe(operators_1.takeUntil(this.ngUnsubscribe))
            .subscribe(function (val) {
            _this.getEnquiries(val);
        });
        this.filterFC.valueChanges
            .pipe(operators_1.takeUntil(this.ngUnsubscribe), operators_1.debounceTime(500), operators_1.distinctUntilChanged())
            .subscribe(function (val) {
            _this.dataSource.filter = val;
        });
        this.monthsAgoFC.setValue(12);
        this.activatedRoute.paramMap
            .pipe(operators_1.takeUntil(this.ngUnsubscribe))
            .subscribe(function (params) { return _this.filterFC.setValue(params.get("search")); }, function (err) { return console.log(err); });
    };
    EnquiryListComponent.prototype.ngAfterViewInit = function () {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    };
    EnquiryListComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    EnquiryListComponent.prototype.getEnquiries = function (monthsAgo) {
        var _this = this;
        this.loading = true;
        this.enquiryService.getListing(monthsAgo)
            .then(function (data) {
            _this.loading = false;
            _this.dataSource.data = data;
        })
            .catch(function (err) {
            _this.loading = false;
            _this.snackBarService.openSnackBar(err);
        });
    };
    EnquiryListComponent.prototype.goToEnquiry = function (enquiryID) {
        this.router.navigate(["enquiries", enquiryID]);
    };
    EnquiryListComponent.prototype.goToNewEnquiry = function () {
        this.router.navigate(["enquiries/new"]);
    };
    EnquiryListComponent.prototype.openEmailHistoryDialog = function (enquiryID) {
        var dialogRef = this.dialog.open(email_history_dialog_component_1.EmailHistoryDialogComponent, {
            width: "800px",
            data: {
                enquiryID: enquiryID
            }
        });
    };
    __decorate([
        core_1.ViewChild(material_1.MatPaginator),
        __metadata("design:type", material_1.MatPaginator)
    ], EnquiryListComponent.prototype, "paginator", void 0);
    __decorate([
        core_1.ViewChild(material_1.MatSort),
        __metadata("design:type", material_1.MatSort)
    ], EnquiryListComponent.prototype, "sort", void 0);
    EnquiryListComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(649),
            styles: [__webpack_require__(650)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute,
            material_1.MatDialog,
            enquiry_service_1.EnquiryService,
            router_1.Router,
            snack_bar_service_1.SnackBarService])
    ], EnquiryListComponent);
    return EnquiryListComponent;
}());
exports.EnquiryListComponent = EnquiryListComponent;


/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var material_1 = __webpack_require__(29);
var email_service_1 = __webpack_require__(182);
var snack_bar_service_1 = __webpack_require__(44);
var EmailHistoryDialogComponent = /** @class */ (function () {
    function EmailHistoryDialogComponent(data, dialogRef, emailService, snackBarService) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.emailService = emailService;
        this.snackBarService = snackBarService;
    }
    EmailHistoryDialogComponent.prototype.ngOnInit = function () {
        this.enquiryID = this.data.enquiryID;
        this.getEmails();
    };
    EmailHistoryDialogComponent.prototype.getEmails = function () {
        var _this = this;
        this.loading = true;
        this.emailService.getListing(this.enquiryID)
            .then(function (list) {
            _this.loading = false;
            _this.emailList = list;
        })
            .catch(function (err) {
            _this.loading = false;
            _this.snackBarService.openSnackBar(err);
        });
    };
    EmailHistoryDialogComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(647),
            styles: [__webpack_require__(648)]
        }),
        __param(0, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [Object, material_1.MatDialogRef,
            email_service_1.EmailService,
            snack_bar_service_1.SnackBarService])
    ], EmailHistoryDialogComponent);
    return EmailHistoryDialogComponent;
}());
exports.EmailHistoryDialogComponent = EmailHistoryDialogComponent;


/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var material_1 = __webpack_require__(29);
var SnackBarService = /** @class */ (function () {
    function SnackBarService(snackBar) {
        this.snackBar = snackBar;
    }
    SnackBarService.prototype.openSnackBar = function (message, action) {
        this.snackBar.open(message, action || "DISMISS", {
            duration: 3000,
        });
    };
    SnackBarService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [material_1.MatSnackBar])
    ], SnackBarService);
    return SnackBarService;
}());
exports.SnackBarService = SnackBarService;


/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var platform_browser_dynamic_1 = __webpack_require__(248);
var core_1 = __webpack_require__(1);
var app_module_1 = __webpack_require__(615);
if (true) {
    core_1.enableProdMode();
}
platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.AppModule)
    .then(function (success) { return console.log("Bootstrap success."); })
    .catch(function (err) { return console.error(err); });


/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var platform_browser_1 = __webpack_require__(39);
var animations_1 = __webpack_require__(35);
var http_1 = __webpack_require__(33);
var angular_jwt_1 = __webpack_require__(172);
var http_2 = __webpack_require__(33);
var common_1 = __webpack_require__(3);
var en_AU_1 = __webpack_require__(616);
common_1.registerLocaleData(en_AU_1.default);
var admin_module_1 = __webpack_require__(617);
var app_routing_module_1 = __webpack_require__(627);
var auth_module_1 = __webpack_require__(634);
var core_module_1 = __webpack_require__(636);
var enquiry_module_1 = __webpack_require__(638);
var shared_module_1 = __webpack_require__(109);
var app_component_1 = __webpack_require__(651);
var introducer_search_service_1 = __webpack_require__(279);
var login_component_1 = __webpack_require__(276);
var perspective_component_1 = __webpack_require__(278);
var perspective_interceptor_1 = __webpack_require__(656);
var perspective_service_1 = __webpack_require__(87);
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    AppModule = __decorate([
        core_1.NgModule({
            imports: [
                platform_browser_1.BrowserModule,
                animations_1.BrowserAnimationsModule,
                http_1.HttpClientModule,
                angular_jwt_1.JwtModule.forRoot({
                    config: {
                        tokenGetter: function () {
                            return localStorage.getItem("access_token");
                        }
                    }
                }),
                admin_module_1.AdminModule,
                app_routing_module_1.AppRoutingModule,
                auth_module_1.AuthModule,
                core_module_1.CoreModule,
                enquiry_module_1.EnquiryModule,
                shared_module_1.SharedModule,
            ],
            declarations: [
                app_component_1.AppComponent,
                login_component_1.LoginComponent,
                perspective_component_1.PerspectiveComponent
            ],
            providers: [
                perspective_service_1.PerspectiveService,
                introducer_search_service_1.IntroducerSearchService,
                { provide: http_2.HTTP_INTERCEPTORS, useClass: perspective_interceptor_1.PerspectiveInterceptor, multi: true },
                { provide: core_1.LOCALE_ID, useValue: "en-AU" }
            ],
            bootstrap: [app_component_1.AppComponent]
        })
    ], AppModule);
    return AppModule;
}());
exports.AppModule = AppModule;


/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(null, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // THIS CODE IS GENERATED - DO NOT MODIFY
    // See angular/tools/gulp-tasks/cldr/extract.js
    var u = undefined;
    function plural(n) {
        var i = Math.floor(Math.abs(n)), v = n.toString().replace(/^[^.]*\.?/, '').length;
        if (i === 1 && v === 0)
            return 1;
        return 5;
    }
    exports.default = [
        'en-AU', [['am', 'pm'], u, u], u,
        [
            ['Su.', 'M.', 'Tu.', 'W.', 'Th.', 'F.', 'Sa.'],
            ['Sun.', 'Mon.', 'Tue.', 'Wed.', 'Thu.', 'Fri.', 'Sat.'],
            ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            ['Su.', 'Mon.', 'Tu.', 'Wed.', 'Th.', 'Fri.', 'Sat.']
        ],
        u,
        [
            ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
            ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'],
            [
                'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September',
                'October', 'November', 'December'
            ]
        ],
        u, [['B', 'A'], ['BC', 'AD'], ['Before Christ', 'Anno Domini']], 0, [6, 0],
        ['d/M/yy', 'd MMM y', 'd MMMM y', 'EEEE, d MMMM y'],
        ['h:mm a', 'h:mm:ss a', 'h:mm:ss a z', 'h:mm:ss a zzzz'], ['{1}, {0}', u, '{1} \'at\' {0}', u],
        ['.', ',', ';', '%', '+', '-', 'e', '×', '‰', '∞', 'NaN', '.'],
        ['#,##0.###', '#,##0%', '¤#,##0.00', '#E0'], '$', 'Australian Dollar', {
            'AUD': ['$'],
            'BDT': [u, 'Tk'],
            'BOB': [u, '$b'],
            'BRL': [u, 'R$'],
            'CAD': [u, '$'],
            'CNY': [u, '¥'],
            'CUP': [u, '₱'],
            'EGP': [u, '£'],
            'EUR': [u, '€'],
            'GBP': [u, '£'],
            'HKD': [u, '$'],
            'ILS': [u, '₪'],
            'INR': [u, '₹'],
            'ISK': [u, 'Kr'],
            'JPY': [u, '¥'],
            'KRW': [u, '₩'],
            'MXN': [u, '$'],
            'NZD': [u, '$'],
            'PYG': [u, 'Gs'],
            'SCR': ['Rs'],
            'SEK': [u, 'Kr'],
            'TWD': [u, '$'],
            'USD': [u, '$'],
            'UYU': [u, '$U'],
            'VND': [u, '₫'],
            'XAF': [],
            'XCD': [u, '$'],
            'XOF': [],
            'XPF': ['CFP']
        },
        plural
    ];
});
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var admin_routing_module_1 = __webpack_require__(618);
var shared_module_1 = __webpack_require__(109);
var user_service_1 = __webpack_require__(178);
var theme_settings_component_1 = __webpack_require__(272);
var user_detail_component_1 = __webpack_require__(273);
var user_list_component_1 = __webpack_require__(275);
var AdminModule = /** @class */ (function () {
    function AdminModule() {
    }
    AdminModule = __decorate([
        core_1.NgModule({
            imports: [
                admin_routing_module_1.AdminRoutingModule,
                shared_module_1.SharedModule,
            ],
            declarations: [
                theme_settings_component_1.ThemeSettingsComponent,
                user_detail_component_1.UserDetailComponent,
                user_list_component_1.UserListComponent,
            ],
            providers: [
                user_service_1.UserService
            ]
        })
    ], AdminModule);
    return AdminModule;
}());
exports.AdminModule = AdminModule;


/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var router_1 = __webpack_require__(26);
var auth_guard_service_1 = __webpack_require__(130);
var theme_settings_component_1 = __webpack_require__(272);
var user_detail_component_1 = __webpack_require__(273);
var user_list_component_1 = __webpack_require__(275);
var adminRoutes = [
    { path: "theme", component: theme_settings_component_1.ThemeSettingsComponent, canActivate: [auth_guard_service_1.AuthGuard] },
    { path: "users", component: user_list_component_1.UserListComponent, canActivate: [auth_guard_service_1.AuthGuard] },
    { path: "users/:id", component: user_detail_component_1.UserDetailComponent, canActivate: [auth_guard_service_1.AuthGuard] },
];
var AdminRoutingModule = /** @class */ (function () {
    function AdminRoutingModule() {
    }
    AdminRoutingModule = __decorate([
        core_1.NgModule({
            imports: [router_1.RouterModule.forChild(adminRoutes)],
            exports: [router_1.RouterModule]
        })
    ], AdminRoutingModule);
    return AdminRoutingModule;
}());
exports.AdminRoutingModule = AdminRoutingModule;


/***/ }),

/***/ 619:
/***/ (function(module, exports) {

module.exports = "<form [formGroup]=\"themeForm\" novalidate>\r\n    <mat-card>\r\n        <mat-card-header fxLayoutAlign=\"start center\">\r\n            <mat-icon matCardAvatar class=\"card-avatar-fix\">format_color_fill</mat-icon>\r\n            <mat-card-title>Theme Settings</mat-card-title>\r\n        </mat-card-header>\r\n\r\n        <mat-card-content>\r\n            <div *ngIf=\"showLoadingSpinner(); else themeSettingsArea\" fxLayout=\"row\" fxLayoutAlign=\"center\">\r\n                <mat-spinner mode=\"indeterminate\"></mat-spinner>\r\n            </div>\r\n\r\n            <ng-template #themeSettingsArea>\r\n                <div fxLayout.gt-md=\"row\" fxLayoutGap.gt-md=\"20px\" fxLayout=\"column\">\r\n                    <div fxFlex=\"33\">\r\n                        <p>Select toolbar colour:</p>\r\n                        <!-- see https://github.com/zefoy/ngx-color-picker -->\r\n                        <input [formControl]=\"primaryColourFC\"\r\n                               [colorPicker]=\"primaryColourFC.value\"\r\n                               (colorPickerChange)=\"primaryColourFC.setValue($event)\"\r\n                               [style.background]=\"primaryColourFC.value\"\r\n                               [cpPosition]=\"'bottom'\" />\r\n                    </div>\r\n\r\n                    <div fxFlex=\"33\">\r\n                        <p>Upload a new logo. It will be displayed in the navbar, and on generated quote documents. The image should:</p>\r\n                        <ul>\r\n                            <li>Not be larger than 300x50 px (will be scaled).</li>\r\n                            <li>Ideally have a transparent background.</li>\r\n                            <li>Must be PNG format.</li>\r\n                            <li>Must be less than 100KB in size.</li>\r\n                        </ul>\r\n\r\n                        <!-- Need to use tricks to style the built-in browser <input type=\"file\" /> see https://stackoverflow.com/a/17949302 -->\r\n                        <input type=\"file\" id=\"chooseFile\" [formControl]=\"fileInputFC\" (change)=\"onFileChange($event)\" style=\"display:none\" />\r\n                        <label for=\"chooseFile\" fxLayout=\"row\" fxLayoutAlign=\"start center\" fxLayoutGap=\"5px\" class=\"file-chooser\">\r\n                            <mat-icon>file_upload</mat-icon> <span>Select a File</span>\r\n                        </label>\r\n\r\n                        <p *ngIf=\"navbarLogoFC?.value\">\r\n                            Selected: {{navbarLogoFC?.value?.fileName}}\r\n                        </p>\r\n\r\n                        <div *ngIf=\"getPreviewLogo()\">\r\n                            <img [src]=\"getPreviewLogo()\" alt=\"preview-logo\" class=\"navbar-logo\" />\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div fxFlex=\"33\">\r\n\r\n                    </div>\r\n                </div>\r\n            </ng-template>\r\n        </mat-card-content>\r\n\r\n        <mat-card-actions>\r\n            <div fxLayout=\"row\" fxLayoutGap=\"10px\" fxLayoutAlign=\"end center\">\r\n                <div class=\"small-spinner\">\r\n                    <mat-spinner *ngIf=\"showSaveSpinner()\" mode=\"indeterminate\"></mat-spinner>\r\n                </div>\r\n                <button mat-raised-button type=\"button\" (click)=\"goToEnquiriesList()\">CANCEL</button>\r\n                <button mat-raised-button type=\"button\" color=\"primary\" (click)=\"save()\" [disabled]=\"actionsDisabled()\">SAVE</button>\r\n            </div>\r\n        </mat-card-actions>\r\n    </mat-card>\r\n</form>";

/***/ }),

/***/ 620:
/***/ (function(module, exports) {

module.exports = ".file-chooser {\r\n    cursor: pointer;\r\n    max-width: 120px;\r\n}"

/***/ }),

/***/ 621:
/***/ (function(module, exports) {

module.exports = "<h1 mat-dialog-title>Confirm Action</h1>\r\n\r\n<mat-dialog-content>\r\n    <p>{{question}}</p>\r\n</mat-dialog-content>\r\n\r\n<mat-dialog-actions fxLayout=\"row\" fxLayoutAlign=\"end\" fxLayoutGap=\"10px\">\r\n    <button mat-button type=\"button\" color=\"primary\" mat-dialog-close>{{cancelButtonLabel}}</button>\r\n    <button mat-raised-button type=\"button\" color=\"primary\" (click)=\"actionConfirmed()\">{{confirmButtonLabel}}</button>\r\n</mat-dialog-actions>";

/***/ }),

/***/ 622:
/***/ (function(module, exports) {

module.exports = "<div class=\"info-area\">\r\n    <button mat-raised-button type=\"button\" (click)=\"goToUsersList()\">BACK</button>\r\n</div>\r\n\r\n<form [formGroup]=\"userForm\" novalidate>\r\n    <mat-card>\r\n        <mat-card-header fxLayoutAlign=\"start center\">\r\n            <mat-icon matCardAvatar class=\"card-avatar-fix\">person_outline</mat-icon>\r\n            <mat-card-title>Manage User</mat-card-title>\r\n        </mat-card-header>\r\n\r\n        <mat-card-content>\r\n            <div *ngIf=\"showLoadingSpinner(); else userArea\" fxLayout=\"row\" fxLayoutAlign=\"center\">\r\n                <mat-spinner mode=\"indeterminate\"></mat-spinner>\r\n            </div>\r\n\r\n            <ng-template #userArea>\r\n                <div fxLayout.gt-md=\"row\" fxLayoutGap.gt-md=\"20px\" fxLayout=\"column\" >\r\n                    <div fxFlex=\"33\" fxLayout=\"column\">\r\n                        <mat-form-field>\r\n                            <input matInput type=\"text\" placeholder=\"Username\" formControlName=\"username\">\r\n                        </mat-form-field>\r\n\r\n                        <mat-form-field>\r\n                            <mat-select placeholder=\"Name Title\" formControlName=\"nameTitleCode\">\r\n                                <mat-option *ngFor=\"let opt of userOpts.nameTitles\" [value]=\"opt.code\">\r\n                                    {{opt.label}}\r\n                                </mat-option>\r\n                            </mat-select>\r\n                        </mat-form-field>\r\n\r\n                        <mat-form-field>\r\n                            <input matInput type=\"text\" placeholder=\"First Name\" formControlName=\"firstName\" required>\r\n                            <mat-error *ngIf=\"userForm.get('firstName').hasError('maxlength')\" align=\"end\">Max length 60 characters.</mat-error>\r\n                            <mat-error *ngIf=\"userForm.get('firstName').hasError('required')\" align=\"end\">Required.</mat-error>\r\n                        </mat-form-field>\r\n\r\n                        <mat-form-field>\r\n                            <input matInput type=\"text\" placeholder=\"Middle Name\" formControlName=\"middleName\">\r\n                            <mat-error *ngIf=\"userForm.get('middleName').hasError('maxlength')\" align=\"end\">Max length 60 characters.</mat-error>\r\n                        </mat-form-field>\r\n\r\n                        <mat-form-field>\r\n                            <input matInput type=\"text\" placeholder=\"Last Name\" formControlName=\"lastName\" required>\r\n                            <mat-error *ngIf=\"userForm.get('lastName').hasError('maxlength')\" align=\"end\">Max length 60 characters.</mat-error>\r\n                            <mat-error *ngIf=\"userForm.get('lastName').hasError('required')\" align=\"end\">Required.</mat-error>\r\n                        </mat-form-field>\r\n\r\n                        <mat-form-field>\r\n                            <input matInput type=\"email\" placeholder=\"Email\" formControlName=\"emailAddress\" required>\r\n                            <mat-error *ngIf=\"userForm.get('emailAddress').hasError('maxlength')\" align=\"end\">Max length 100 characters.</mat-error>\r\n                            <mat-error *ngIf=\"userForm.get('emailAddress').hasError('required')\" align=\"end\">Required.</mat-error>\r\n                        </mat-form-field>\r\n\r\n                        <mat-form-field>\r\n                            <input matInput type=\"tel\" placeholder=\"Phone\" formControlName=\"phoneNumber\" maxlength=\"20\">\r\n                        </mat-form-field>\r\n\r\n                        <mat-form-field>\r\n                            <input matInput type=\"tel\" placeholder=\"Mobile\" formControlName=\"mobileNumber\" maxlength=\"20\">\r\n                        </mat-form-field>\r\n\r\n                        <mat-form-field>\r\n                            <input matInput type=\"text\" placeholder=\"Job Title\" formControlName=\"jobTitle\">\r\n                            <mat-error *ngIf=\"userForm.get('jobTitle').hasError('maxlength')\" align=\"end\">Max length 100 characters.</mat-error>\r\n                        </mat-form-field>\r\n                    </div>\r\n\r\n                    <div fxFlex=\"33\" fxLayout=\"column\" fxLayoutGap=\"10px\">\r\n                        <mat-checkbox formControlName=\"isWebAdmin\">Administrator</mat-checkbox>\r\n                        <mat-checkbox formControlName=\"isActive\">Active</mat-checkbox>\r\n                        <mat-checkbox formControlName=\"isLocked\">Locked</mat-checkbox>\r\n                    </div>\r\n\r\n                    <div fxFlex=\"33\" fxLayout=\"column\">\r\n                        <div>\r\n                            <button mat-raised-button type=\"button\" color=\"warn\" (click)=\"resetPassword()\" [disabled]=\"actionsDisabled()\" class=\"reset\">RESET PASSWORD</button>\r\n                        </div>\r\n\r\n                        <mat-form-field *ngIf=\"showTemporaryPassword()\">\r\n                            <input matInput type=\"text\" placeholder=\"Temporary Password\" formControlName=\"temporaryPassword\">\r\n                        </mat-form-field>\r\n                    </div>\r\n                </div>\r\n            </ng-template>\r\n        </mat-card-content>\r\n\r\n        <mat-card-actions>\r\n            <div fxLayout=\"row\" fxLayoutGap=\"10px\" fxLayoutAlign=\"end center\">\r\n                <div class=\"small-spinner\">\r\n                    <mat-spinner *ngIf=\"showSaveSpinner()\" mode=\"indeterminate\"></mat-spinner>\r\n                </div>\r\n                <button mat-raised-button type=\"button\" (click)=\"goToUsersList()\">CANCEL</button>\r\n                <button mat-raised-button type=\"button\" color=\"primary\" (click)=\"save()\" [disabled]=\"actionsDisabled()\">SAVE</button>\r\n            </div>\r\n        </mat-card-actions>\r\n    </mat-card>\r\n</form>";

/***/ }),

/***/ 623:
/***/ (function(module, exports) {

module.exports = ".info-area {\r\n    margin: 10px;\r\n}\r\n\r\n.reset {\r\n    margin-top: 10px;\r\n    margin-bottom: 20px;\r\n}"

/***/ }),

/***/ 624:
/***/ (function(module, exports) {

module.exports = "<div fxLayout=\"row\">\r\n    <mat-form-field>\r\n        <input matInput [formControl]=\"filterFC\" placeholder=\"Search\">\r\n    </mat-form-field>\r\n</div>\r\n\r\n<div class=\"container\">\r\n    <div class=\"table-loading-shade\" *ngIf=\"loading\">\r\n        <mat-spinner></mat-spinner>\r\n    </div>\r\n\r\n    <mat-table #table [dataSource]=\"userDataSource\" class=\"user-table\"\r\n               matSort matSortActive=\"isWebAdmin\" matSortDisableClear matSortDirection=\"desc\">\r\n\r\n        <ng-container matColumnDef=\"username\">\r\n            <mat-header-cell *matHeaderCellDef mat-sort-header>\r\n                Username\r\n            </mat-header-cell>\r\n            <mat-cell *matCellDef=\"let row\">\r\n                {{ row.username }}\r\n            </mat-cell>\r\n        </ng-container>\r\n\r\n        <ng-container matColumnDef=\"fullName\">\r\n            <mat-header-cell *matHeaderCellDef mat-sort-header>\r\n                Full Name\r\n            </mat-header-cell>\r\n            <mat-cell *matCellDef=\"let row\">\r\n                {{ row.fullName }}\r\n            </mat-cell>\r\n        </ng-container>\r\n\r\n        <ng-container matColumnDef=\"isWebAdmin\">\r\n            <mat-header-cell *matHeaderCellDef mat-sort-header fxLayoutAlign=\"center\">\r\n                Role\r\n            </mat-header-cell>\r\n            <mat-cell *matCellDef=\"let row\" fxLayoutAlign=\"center center\">\r\n                {{ row.isWebAdmin ? 'Admin' : 'User' }}\r\n            </mat-cell>\r\n        </ng-container>\r\n\r\n        <ng-container matColumnDef=\"isActive\">\r\n            <mat-header-cell *matHeaderCellDef mat-sort-header fxLayoutAlign=\"center\">\r\n                Active\r\n            </mat-header-cell>\r\n            <mat-cell *matCellDef=\"let row\" fxLayoutAlign=\"center center\">\r\n                {{ row.isActive ? 'Yes' : 'No' }}\r\n            </mat-cell>\r\n        </ng-container>\r\n\r\n        <ng-container matColumnDef=\"isLocked\">\r\n            <mat-header-cell *matHeaderCellDef mat-sort-header fxLayoutAlign=\"center\">\r\n                Locked\r\n            </mat-header-cell>\r\n            <mat-cell *matCellDef=\"let row\" fxLayoutAlign=\"center center\">\r\n                {{ row.isLocked ? 'Yes' : 'No' }}\r\n            </mat-cell>\r\n        </ng-container>\r\n\r\n        <ng-container matColumnDef=\"actions\">\r\n            <mat-header-cell *matHeaderCellDef>\r\n                Actions\r\n            </mat-header-cell>\r\n            <mat-cell *matCellDef=\"let row\">\r\n                <button mat-icon-button type=\"button\" (click)=\"goToUser(row.id)\">\r\n                    <mat-icon>edit</mat-icon>\r\n                </button>\r\n            </mat-cell>\r\n        </ng-container>\r\n\r\n        <mat-header-row *matHeaderRowDef=\"displayedColumns\"></mat-header-row>\r\n        <mat-row *matRowDef=\"let row; columns: displayedColumns;\"></mat-row>\r\n    </mat-table>\r\n\r\n    <mat-paginator [pageSize]=\"15\"></mat-paginator>\r\n</div>";

/***/ }),

/***/ 625:
/***/ (function(module, exports) {

module.exports = ".container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    position: relative;\r\n}\r\n\r\n.user-table {\r\n    overflow: auto;\r\n    min-width: 700px;\r\n}\r\n\r\n.mat-column-username,\r\n.mat-column-fullName {\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    min-width: 170px;\r\n}\r\n\r\n.mat-column-isWebAdmin,\r\n.mat-column-isActive,\r\n.mat-column-isLocked,\r\n.mat-column-actions {\r\n    min-width: 60px;\r\n    max-width: 100px;\r\n}"

/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var material_1 = __webpack_require__(29);
var FAWMaterialModule = /** @class */ (function () {
    function FAWMaterialModule() {
    }
    FAWMaterialModule = __decorate([
        core_1.NgModule({
            imports: [
                material_1.MatAutocompleteModule,
                material_1.MatButtonModule,
                material_1.MatCardModule,
                material_1.MatCheckboxModule,
                material_1.MatChipsModule,
                material_1.MatDialogModule,
                material_1.MatIconModule,
                material_1.MatInputModule,
                material_1.MatListModule,
                material_1.MatMenuModule,
                material_1.MatOptionModule,
                material_1.MatPaginatorModule,
                material_1.MatProgressSpinnerModule,
                material_1.MatRadioModule,
                material_1.MatSelectModule,
                material_1.MatSidenavModule,
                material_1.MatSnackBarModule,
                material_1.MatSortModule,
                material_1.MatTableModule,
                material_1.MatTabsModule,
                material_1.MatToolbarModule,
                material_1.MatTooltipModule
            ],
            exports: [
                material_1.MatAutocompleteModule,
                material_1.MatButtonModule,
                material_1.MatCardModule,
                material_1.MatCheckboxModule,
                material_1.MatChipsModule,
                material_1.MatDialogModule,
                material_1.MatIconModule,
                material_1.MatInputModule,
                material_1.MatListModule,
                material_1.MatMenuModule,
                material_1.MatOptionModule,
                material_1.MatPaginatorModule,
                material_1.MatProgressSpinnerModule,
                material_1.MatRadioModule,
                material_1.MatSelectModule,
                material_1.MatSidenavModule,
                material_1.MatSnackBarModule,
                material_1.MatSortModule,
                material_1.MatTableModule,
                material_1.MatTabsModule,
                material_1.MatToolbarModule,
                material_1.MatTooltipModule
            ],
            providers: [
                { provide: material_1.MAT_LABEL_GLOBAL_OPTIONS, useValue: { float: "always" } }
            ]
        })
    ], FAWMaterialModule);
    return FAWMaterialModule;
}());
exports.FAWMaterialModule = FAWMaterialModule;


/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var router_1 = __webpack_require__(26);
var auth_guard_service_1 = __webpack_require__(130);
var login_component_1 = __webpack_require__(276);
var perspective_component_1 = __webpack_require__(278);
var routes = [
    { path: "login", component: login_component_1.LoginComponent },
    { path: "perspective", component: perspective_component_1.PerspectiveComponent, canActivate: [auth_guard_service_1.AuthGuard] },
    { path: "", redirectTo: "/login", pathMatch: "full" },
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    AppRoutingModule = __decorate([
        core_1.NgModule({
            imports: [router_1.RouterModule.forRoot(routes)],
            exports: [router_1.RouterModule]
        })
    ], AppRoutingModule);
    return AppRoutingModule;
}());
exports.AppRoutingModule = AppRoutingModule;


/***/ }),

/***/ 628:
/***/ (function(module, exports) {

module.exports = "<h2 matDialogTitle>Change Password</h2>\r\n\r\n<form (ngSubmit)=\"onSubmit()\" [formGroup]=\"changePasswordForm\" novalidate>\r\n    <mat-dialog-content>\r\n        <div fxLayout=\"column\">\r\n            <div *ngIf=\"passwordChangeMandatory\" fxLayout=\"row\" fxLayoutAlign=\"center center\" fxLayoutGap=\"5px\" class=\"message\">\r\n                <mat-icon>warning</mat-icon>\r\n                <span>Your account is using a temporary password, please update it before proceeding.</span>\r\n            </div>\r\n\r\n            <mat-form-field>\r\n                <input matInput type=\"password\" placeholder=\"New Password\" formControlName=\"newPassword\">\r\n                <mat-error *ngIf=\"newPasswordFC.hasError('maxlength')\" align=\"end\">Max length 100 characters.</mat-error>\r\n                <mat-error *ngIf=\"newPasswordFC.hasError('required')\" align=\"end\">Required.</mat-error>\r\n            </mat-form-field>\r\n\r\n            <mat-form-field>\r\n                <input matInput type=\"password\" placeholder=\"Confirm Password\" formControlName=\"confirmPassword\">\r\n                <mat-error *ngIf=\"confirmPasswordFC.hasError('maxlength')\" align=\"end\">Max length 100 characters.</mat-error>\r\n                <mat-error *ngIf=\"confirmPasswordFC.hasError('required')\" align=\"end\">Required.</mat-error>\r\n                <!--workaround for mat-error with a custom validator - see https://github.com/angular/material2/issues/4027 -->\r\n                <mat-hint *ngIf=\"showPasswordMismatchError()\" align=\"end\" style=\"color:red\">Passwords do not match.</mat-hint>\r\n            </mat-form-field>\r\n        </div>\r\n    </mat-dialog-content>\r\n\r\n    <mat-dialog-actions align=\"end\">\r\n        <div class=\"small-spinner button-spinner\">\r\n            <mat-spinner *ngIf=\"showSpinner()\" mode=\"indeterminate\"></mat-spinner>\r\n        </div>\r\n        <button *ngIf=\"!passwordChangeMandatory\" mat-button matDialogClose>CANCEL</button>\r\n        <button mat-raised-button color=\"primary\" type=\"submit\" [disabled]=\"actionsDisabled()\">SUBMIT</button>\r\n    </mat-dialog-actions>\r\n</form>\r\n";

/***/ }),

/***/ 629:
/***/ (function(module, exports) {

module.exports = ".message {\r\n    margin-bottom: 20px;\r\n}"

/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"login-container\">\r\n    <form novalidate (ngSubmit)=\"onSubmit()\" [formGroup]=\"loginForm\" fxLayout=\"column\" fxLayoutAlign=\"center center\" fxLayoutGap=\"15px\">\r\n        <div>\r\n            <img src=\"" + __webpack_require__(631) + "\" />\r\n        </div>\r\n        <!-- FAW requested this login page have a similar appearance to their existing website - some styles taken from http://financeatwork.com.au/wp-login.php -->\r\n        <mat-card style=\"width:260px\">\r\n            <div class=\"login-form-field\">\r\n                <label>\r\n                    Username or Email Address<br>\r\n                    <input type=\"text\" formControlName=\"username\" maxlength=\"100\">\r\n                </label>\r\n            </div>\r\n            <div class=\"login-form-field\">\r\n                <label>\r\n                    Password<br>\r\n                    <input type=\"password\" formControlName=\"password\" maxlength=\"100\">\r\n                </label>\r\n            </div>\r\n\r\n            <div *ngIf=\"message\" fxLayout=\"row\" fxLayoutAlign=\"center center\">\r\n                <mat-icon color=\"warn\">warning</mat-icon>\r\n                <span class=\"message-text\">{{message}}</span>\r\n            </div>\r\n\r\n            <div fxLayout=\"row\" fxLayoutAlign=\"center center\" fxLayoutGap=\"10px\">\r\n                <span fxFlex></span>\r\n                <div *ngIf=\"loading\" class=\"small-spinner\">\r\n                    <mat-spinner mode=\"indeterminate\"></mat-spinner>\r\n                </div>\r\n                <button mat-raised-button class=\"login-button\" type=\"submit\" [disabled]=\"loading\">Log In</button>\r\n            </div>\r\n        </mat-card>\r\n\r\n        <a href=\"http://financeatwork.com.au/\" class=\"link-text\">← Back to Finance@work Pty Ltd</a>\r\n\r\n        <div class=\"message-text\">\r\n            <span>Version {{appVersion}} [{{releaseDate}}]</span>\r\n        </div>\r\n    </form>\r\n</div>";

/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/faw-logo-login.38f2d32a6cbeed57ad808e55446c4a64.png";

/***/ }),

/***/ 632:
/***/ (function(module, exports) {

module.exports = ".login-container {\r\n    padding: 8% 0 0;\r\n}\r\n\r\n.message-text {\r\n    padding: 5px;\r\n    font-size: 12px;\r\n}\r\n\r\n.login-form-field label {\r\n    cursor: pointer;\r\n    color: #72777c;\r\n    font-size: 14px;\r\n}\r\n\r\n.login-form-field label input {\r\n    background: #fbfbfb;\r\n\r\n    font-size: 24px;\r\n    width: 100%;\r\n    padding: 3px;\r\n    margin: 2px 6px 16px 0;\r\n\r\n    border: 1px solid #ddd;\r\n    box-shadow: inset 0 1px 2px rgba(0,0,0,.07);\r\n    /*background-color: #fff;*/\r\n    color: #32373c;\r\n    outline: 0;\r\n    transition: 50ms border-color ease-in-out;\r\n}\r\n\r\n.login-form-field label input:focus {\r\n    border-color: #5b9dd9;\r\n    box-shadow: 0 0 2px rgba(30,140,190,.8);\r\n}\r\n\r\n.login-button {\r\n    background-color: #0085ba;\r\n    color: #fff;\r\n}\r\n\r\n.link-text:hover {\r\n    color: #00a0d2;\r\n}\r\n\r\n.link-text {\r\n    font-size: 13px;\r\n    text-decoration: none;\r\n    color: #555d66;\r\n    transition-property: border,background,color;\r\n    transition-duration: .05s;\r\n    transition-timing-function: ease-in-out;\r\n    outline: 0;\r\n}"

/***/ }),

/***/ 633:
/***/ (function(module, exports) {

module.exports = "<div fxLayout=\"row\" fxLayoutAlign=\"center\">\r\n    <mat-card fxFlex.gt-sm=\"50\">\r\n        <mat-card-header fxLayoutAlign=\"start center\">\r\n            <mat-icon matCardAvatar class=\"card-avatar-fix\">visibility</mat-icon>\r\n            <mat-card-title>{{perspectiveService.activeIntroducer ? 'Change' : 'Set'}} Perspective</mat-card-title>\r\n        </mat-card-header>\r\n\r\n        <mat-card-content>\r\n            <div fxLayout=\"row\" fxLayoutAlign=\"start center\" fxLayoutGap=\"15px\">\r\n                <mat-form-field fxFlex=\"90\">\r\n                    <input matInput placeholder=\"Search Suppliers\" [matAutocomplete]=\"auto\" [formControl]=\"searchFC\">\r\n                    <mat-autocomplete #auto=\"matAutocomplete\" (optionSelected)=\"setPerspective($event)\">\r\n                        <mat-option *ngFor=\"let sup of filteredIntroducers$ | async\" [value]=\"sup\">\r\n                            <span>{{sup.entityNumber}} | {{sup.entityName}}</span> |\r\n                            <small>Trading as \"{{sup.tradingAs || '(Unspecified)'}}\"</small>\r\n                        </mat-option>\r\n                    </mat-autocomplete>\r\n                    <mat-hint align=\"end\">Set your perspective to a specific supplier.</mat-hint>\r\n                </mat-form-field>\r\n\r\n                <div class=\"small-spinner\">\r\n                    <mat-spinner *ngIf=\"loading\" mode=\"indeterminate\"></mat-spinner>\r\n                </div>\r\n            </div>\r\n        </mat-card-content>\r\n    </mat-card>\r\n</div>";

/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var http_1 = __webpack_require__(33);
var shared_module_1 = __webpack_require__(109);
var change_password_dialog_component_1 = __webpack_require__(179);
var auth_guard_service_1 = __webpack_require__(130);
var auth_service_1 = __webpack_require__(85);
var unauth_redirect_interceptor_1 = __webpack_require__(635);
var AuthModule = /** @class */ (function () {
    function AuthModule() {
    }
    AuthModule = __decorate([
        core_1.NgModule({
            imports: [
                shared_module_1.SharedModule,
            ],
            declarations: [
                change_password_dialog_component_1.ChangePasswordDialogComponent,
            ],
            exports: [
                change_password_dialog_component_1.ChangePasswordDialogComponent,
            ],
            entryComponents: [
                change_password_dialog_component_1.ChangePasswordDialogComponent
            ],
            providers: [
                auth_guard_service_1.AuthGuard,
                auth_service_1.AuthService,
                {
                    provide: http_1.HTTP_INTERCEPTORS,
                    useClass: unauth_redirect_interceptor_1.UnauthRedirectInterceptor,
                    multi: true
                }
            ]
        })
    ], AuthModule);
    return AuthModule;
}());
exports.AuthModule = AuthModule;


/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var http_1 = __webpack_require__(33);
var router_1 = __webpack_require__(26);
var operators_1 = __webpack_require__(6);
var UnauthRedirectInterceptor = /** @class */ (function () {
    function UnauthRedirectInterceptor(router) {
        this.router = router;
    }
    // see https://medium.com/@ryanchenkie_40935/angular-authentication-using-the-http-client-and-http-interceptors-2f9d1540eb8
    UnauthRedirectInterceptor.prototype.intercept = function (req, next) {
        var _this = this;
        return next.handle(req)
            .pipe(operators_1.tap(function (event) {
            if (event instanceof http_1.HttpResponse) {
                // do stuff with response if you want
            }
        }, function (err) {
            // todo: logic to use refresh token would go here instead of just redirecting...
            if (err instanceof http_1.HttpErrorResponse) {
                if (err.status === 401 || err.status === 403) {
                    _this.router.navigate(["/login"]);
                }
            }
        }));
    };
    UnauthRedirectInterceptor = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [router_1.Router])
    ], UnauthRedirectInterceptor);
    return UnauthRedirectInterceptor;
}());
exports.UnauthRedirectInterceptor = UnauthRedirectInterceptor;


/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var router_1 = __webpack_require__(26);
var shared_module_1 = __webpack_require__(109);
var confirm_dialog_component_1 = __webpack_require__(274);
var module_import_guard_1 = __webpack_require__(637);
var snack_bar_service_1 = __webpack_require__(44);
var theme_service_1 = __webpack_require__(107);
var validation_helper_service_1 = __webpack_require__(108);
var role_const_1 = __webpack_require__(177);
var CoreModule = /** @class */ (function () {
    function CoreModule(parentModule) {
        module_import_guard_1.throwIfAlreadyLoaded(parentModule, "CoreModule");
    }
    CoreModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule,
                shared_module_1.SharedModule
            ],
            declarations: [
                confirm_dialog_component_1.ConfirmDialogComponent,
            ],
            exports: [
                confirm_dialog_component_1.ConfirmDialogComponent,
            ],
            entryComponents: [
                confirm_dialog_component_1.ConfirmDialogComponent
            ],
            providers: [
                snack_bar_service_1.SnackBarService,
                theme_service_1.ThemeService,
                validation_helper_service_1.ValidationHelperService,
                { provide: role_const_1.role, useValue: role_const_1.Role }
            ]
        }),
        __param(0, core_1.Optional()), __param(0, core_1.SkipSelf()),
        __metadata("design:paramtypes", [CoreModule])
    ], CoreModule);
    return CoreModule;
}());
exports.CoreModule = CoreModule;


/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function throwIfAlreadyLoaded(parentModule, moduleName) {
    if (parentModule) {
        throw new Error(moduleName + " has already been loaded. Import Core modules in the AppModule only.");
    }
}
exports.throwIfAlreadyLoaded = throwIfAlreadyLoaded;


/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var enquiry_routing_module_1 = __webpack_require__(639);
var shared_module_1 = __webpack_require__(109);
var email_service_1 = __webpack_require__(182);
var enquiry_service_1 = __webpack_require__(180);
var document_service_1 = __webpack_require__(181);
var download_quote_dialog_component_1 = __webpack_require__(281);
var email_enquiry_dialog_component_1 = __webpack_require__(282);
var email_history_dialog_component_1 = __webpack_require__(284);
var enquiry_detail_component_1 = __webpack_require__(280);
var enquiry_list_component_1 = __webpack_require__(283);
var EnquiryModule = /** @class */ (function () {
    function EnquiryModule() {
    }
    EnquiryModule = __decorate([
        core_1.NgModule({
            imports: [
                enquiry_routing_module_1.EnquiryRoutingModule,
                shared_module_1.SharedModule,
            ],
            declarations: [
                download_quote_dialog_component_1.DownloadQuoteDialogComponent,
                email_enquiry_dialog_component_1.EmailEnquiryDialogComponent,
                email_history_dialog_component_1.EmailHistoryDialogComponent,
                enquiry_detail_component_1.EnquiryDetailComponent,
                enquiry_list_component_1.EnquiryListComponent,
            ],
            entryComponents: [
                download_quote_dialog_component_1.DownloadQuoteDialogComponent,
                email_enquiry_dialog_component_1.EmailEnquiryDialogComponent,
                email_history_dialog_component_1.EmailHistoryDialogComponent,
            ],
            providers: [
                email_service_1.EmailService,
                enquiry_service_1.EnquiryService,
                document_service_1.DocumentService,
            ]
        })
    ], EnquiryModule);
    return EnquiryModule;
}());
exports.EnquiryModule = EnquiryModule;


/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var router_1 = __webpack_require__(26);
var auth_guard_service_1 = __webpack_require__(130);
var enquiry_detail_component_1 = __webpack_require__(280);
var enquiry_list_component_1 = __webpack_require__(283);
var enquiryRoutes = [
    { path: "enquiries", component: enquiry_list_component_1.EnquiryListComponent, canActivate: [auth_guard_service_1.AuthGuard] },
    { path: "enquiries/new", component: enquiry_detail_component_1.EnquiryDetailComponent, canActivate: [auth_guard_service_1.AuthGuard] },
    { path: "enquiries/:id", component: enquiry_detail_component_1.EnquiryDetailComponent, canActivate: [auth_guard_service_1.AuthGuard] },
];
var EnquiryRoutingModule = /** @class */ (function () {
    function EnquiryRoutingModule() {
    }
    EnquiryRoutingModule = __decorate([
        core_1.NgModule({
            imports: [router_1.RouterModule.forChild(enquiryRoutes)],
            exports: [router_1.RouterModule]
        })
    ], EnquiryRoutingModule);
    return EnquiryRoutingModule;
}());
exports.EnquiryRoutingModule = EnquiryRoutingModule;


/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// see https://stackoverflow.com/a/45514884
exports.atLeastOne = function (validator) { return function (group) {
    var hasAtLeastOne = group && group.controls && Object.keys(group.controls)
        .some(function (k) { return !validator(group.controls[k]); });
    return hasAtLeastOne ? null : {
        atLeastOne: true,
    };
}; };


/***/ }),

/***/ 641:
/***/ (function(module, exports) {

module.exports = "<h2 matDialogTitle>Download Quote</h2>\r\n\r\n<mat-dialog-content>\r\n    <form [formGroup]=\"downloadQuoteForm\" novalidate>\r\n        <div class=\"doc-settings-area\">\r\n            <p class=\"doc-settings-title\">Document Settings</p>\r\n            <mat-checkbox formControlName=\"showAssetCost\">Show Asset Cost</mat-checkbox>\r\n\r\n            <p>Select repayment options to include in the quote document:</p>\r\n            <div [formGroup]=\"repaymentCheckboxesFA\" fxLayout=\"column\" fxLayoutGap=\"8px\">\r\n                <div *ngFor=\"let opt of repaymentOptions; index as i\">\r\n                    <div *ngIf=\"displayPaymentFrequency(i)\" class=\"payment-frequency-heading\">\r\n                        {{opt.paymentFrequencyName}}\r\n                    </div>\r\n                    <mat-checkbox [formControlName]=\"i\">\r\n                        {{opt.repayment | currency:'AUD'}} over {{opt.term}} mths \r\n                        <span *ngIf=\"opt.residualAmount\">{{opt.residualLabelAsBalloon ? 'BA' : 'RV'}} {{opt.residualAmount | currency:'AUD'}}</span>\r\n                    </mat-checkbox>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</mat-dialog-content>\r\n\r\n<mat-dialog-actions align=\"end\">\r\n    <div class=\"small-spinner button-spinner\">\r\n        <mat-spinner *ngIf=\"showSpinner\" mode=\"indeterminate\"></mat-spinner>\r\n    </div>\r\n    <button mat-button matDialogClose>CANCEL</button>\r\n    <button mat-raised-button color=\"primary\" (click)=\"downloadQuote()\" [disabled]=\"showSpinner\">DOWNLOAD</button>\r\n</mat-dialog-actions>\r\n";

/***/ }),

/***/ 642:
/***/ (function(module, exports) {

module.exports = ".doc-settings-area {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.doc-settings-title {\r\n    font-weight: bold;\r\n    margin-top: 0px;\r\n}\r\n\r\n.payment-frequency-heading {\r\n    margin-bottom: 8px;\r\n}"

/***/ }),

/***/ 643:
/***/ (function(module, exports) {

module.exports = "<h2 matDialogTitle>Email</h2>\r\n\r\n<mat-dialog-content>\r\n    <form [formGroup]=\"emailForm\" novalidate>\r\n        <div class=\"doc-settings-area\">\r\n            <p class=\"doc-settings-title\">Document Settings</p>\r\n            <mat-checkbox formControlName=\"showAssetCost\">Show Asset Cost</mat-checkbox>\r\n\r\n            <p>Select repayment options to include in the quote document:</p>\r\n            <div [formGroup]=\"repaymentCheckboxesFA\" fxLayout=\"column\" fxLayoutGap=\"8px\">\r\n                <div *ngFor=\"let opt of repaymentOptions; index as i\">\r\n                    <div *ngIf=\"displayPaymentFrequency(i)\" class=\"payment-frequency-heading\">\r\n                        {{opt.paymentFrequencyName}}\r\n                    </div>\r\n                    <mat-checkbox [formControlName]=\"i\">\r\n                        {{opt.repayment | currency:'AUD'}} over {{opt.term}} mths\r\n                        <span *ngIf=\"opt.residualAmount\">{{opt.residualLabelAsBalloon ? 'BA' : 'RV'}} {{opt.residualAmount | currency:'AUD'}}</span>\r\n                    </mat-checkbox>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        \r\n        <div fxLayout=\"column\">\r\n            <div fxLayout.gt-md=\"row\" fxLayoutAlign.gt-md=\"space-between\" fxLayoutGap.gt-md=\"20px\" fxLayout=\"column\">\r\n                <mat-form-field fxFlex>\r\n                    <input matInput type=\"email\" placeholder=\"To\" formControlName=\"to\" required>\r\n                    <mat-error *ngIf=\"emailForm.get('to').hasError('maxlength')\" align=\"end\">Max length 300 characters.</mat-error>\r\n                    <mat-error *ngIf=\"emailForm.get('to').hasError('required')\" align=\"end\">Required.</mat-error>\r\n                </mat-form-field>\r\n\r\n                <mat-form-field fxFlex>\r\n                    <input matInput type=\"email\" placeholder=\"CC\" formControlName=\"cc\">\r\n                    <mat-error *ngIf=\"emailForm.get('cc').hasError('maxlength')\" align=\"end\">Max length 300 characters.</mat-error>\r\n                    <mat-hint align=\"end\">Use a comma to separate multiple emails.</mat-hint>\r\n                </mat-form-field>\r\n            </div>\r\n\r\n            <div fxLayout.gt-md=\"row\" fxLayoutAlign.gt-md=\"space-between\" fxLayoutGap.gt-md=\"20px\" fxLayout=\"column-reverse\">\r\n                <mat-form-field fxFlex>\r\n                    <input matInput type=\"text\" placeholder=\"Subject\" formControlName=\"subject\">\r\n                    <mat-error *ngIf=\"emailForm.get('subject').hasError('maxlength')\" align=\"end\">Max length 300 characters.</mat-error>\r\n                </mat-form-field>\r\n\r\n                <mat-form-field fxFlex>\r\n                    <input matInput type=\"email\" placeholder=\"BCC\" formControlName=\"bcc\">\r\n                    <mat-error *ngIf=\"emailForm.get('bcc').hasError('maxlength')\" align=\"end\">Max length 300 characters.</mat-error>\r\n                    <mat-hint align=\"end\">Use a comma to separate multiple emails.</mat-hint>\r\n                </mat-form-field>\r\n            </div>\r\n\r\n            <div class=\"info-area\">\r\n                <div>\r\n                    The generated quote document and an application form (if one is available) will be attached automatically, preview either with the buttons below.\r\n                </div>\r\n                <div fxLayout=\"row\" fxLayoutAlign=\"start center\" fxLayoutGap=\"5px\">\r\n                    <mat-icon>warning</mat-icon>\r\n                    <p>iPhone Safari users please note - viewing these files will navigate you away from this web app. Pressing your phone's back button will return you to this enquiry screen, but your email draft and document settings (see above) will be lost.</p>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"file-area\">\r\n                <div fxLayout=\"row wrap\" fxLayoutGap=\"10px\" fxLayoutAlign=\"start center\">\r\n                    <button mat-raised-button type=\"button\" (click)=\"downloadQuote()\" [disabled]=\"showSpinner\">VIEW QUOTE</button>\r\n                    <button mat-raised-button type=\"button\" (click)=\"downloadApplicationForm()\" [disabled]=\"!applicationFormAvailable || showSpinner\">VIEW FORM</button>\r\n                    \r\n                    <!-- Need to use tricks to style the built-in browser <input type=\"file\" /> see https://stackoverflow.com/a/17949302 -->\r\n                    <input type=\"file\" id=\"chooseFile\" [formControl]=\"fileInputFC\" (change)=\"onFileChange($event)\" style=\"display:none\" />\r\n                    <label for=\"chooseFile\" fxLayout=\"row\" fxLayoutAlign=\"start center\" fxLayoutGap=\"5px\" class=\"chip-button\">\r\n                        <mat-icon>attachment</mat-icon> <span>Attach a File</span>\r\n                    </label>\r\n                </div>\r\n\r\n                <div [formGroup]=\"attachmentsFA\"  class=\"attachment-list\">\r\n                    <mat-chip-list>\r\n                        <mat-chip *ngFor=\"let attachment of attachmentsFA.controls; let i=index\">\r\n                            {{attachment.value.fileName}}\r\n                            <mat-icon class=\"chip-button\" (click)=\"removeAttachment(i)\">clear</mat-icon>\r\n                        </mat-chip>\r\n                    </mat-chip-list>\r\n                </div>\r\n            </div>\r\n\r\n            <mat-form-field fxFlex>\r\n                <textarea matInput placeholder=\"Body\" formControlName=\"body\" rows=\"10\"></textarea>\r\n                <mat-error *ngIf=\"emailForm.get('body').hasError('required')\" align=\"end\">Required.</mat-error>\r\n            </mat-form-field>\r\n        </div>\r\n    </form>\r\n</mat-dialog-content>\r\n\r\n<mat-dialog-actions align=\"end\">\r\n    <div class=\"small-spinner button-spinner\">\r\n        <mat-spinner *ngIf=\"showSpinner\" mode=\"indeterminate\"></mat-spinner>\r\n    </div>\r\n    <button mat-button matDialogClose>CANCEL</button>\r\n    <button mat-raised-button color=\"primary\" (click)=\"sendEmail()\" [disabled]=\"showSpinner\">SEND</button>\r\n</mat-dialog-actions>\r\n";

/***/ }),

/***/ 644:
/***/ (function(module, exports) {

module.exports = ".info-area {\r\n    max-width: 800px;\r\n}\r\n\r\n.file-area {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.attachment-list {\r\n    margin-top: 10px;\r\n}\r\n\r\n.doc-settings-area {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.doc-settings-title {\r\n    font-weight: bold;\r\n    margin-top: 0px;\r\n}\r\n\r\n.chip-button {\r\n    cursor: pointer;\r\n}\r\n\r\n.payment-frequency-heading {\r\n    margin-bottom: 8px;\r\n}"

/***/ }),

/***/ 645:
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"errorMessage\" fxLayoutAlign=\"center center\" fxLayoutGap=\"10px\">\r\n    <mat-icon color=\"warn\">warning</mat-icon>\r\n    <span>{{ errorMessage }}</span>\r\n</div>\r\n\r\n<div fxLayout=\"row\" fxLayoutAlign=\"start center\">\r\n    <div>\r\n        <strong>{{ enquiry?.id ? 'Editing' : 'New' }} Enquiry</strong>\r\n    </div>\r\n\r\n    <span fxFlex></span>\r\n\r\n    <div class=\"small-spinner button-spinner\">\r\n        <mat-spinner *ngIf=\"showSavingSpinner()\" mode=\"indeterminate\"></mat-spinner>\r\n    </div>\r\n\r\n    <div fxHide.lt-md>\r\n        <button mat-icon-button type=\"button\" (click)=\"save(false, true)\" [disabled]=\"actionsDisabled()\" matTooltip=\"Email (Enquiry will be saved)\">\r\n            <mat-icon>email</mat-icon>\r\n        </button>\r\n        <button mat-icon-button type=\"button\" (click)=\"save(true, false)\" [disabled]=\"actionsDisabled()\" matTooltip=\"Download Quote (Enquiry will be saved)\">\r\n            <mat-icon>print</mat-icon>\r\n        </button>\r\n        <button mat-icon-button type=\"button\" (click)=\"save()\" [disabled]=\"actionsDisabled()\" matTooltip=\"Save\">\r\n            <mat-icon>save</mat-icon>\r\n        </button>\r\n    </div>\r\n\r\n    <!-- Floating action button - small devices only -->\r\n    <button fxHide.gt-sm mat-fab [disabled]=\"actionsDisabled()\" [matMenuTriggerFor]=\"actionMenu\" class=\"float-fab\" style=\"background-color: #005581;\">\r\n        <mat-icon style=\"color:white\">more_vert</mat-icon>\r\n    </button>\r\n    <mat-menu #actionMenu=\"matMenu\">\r\n        <button mat-menu-item (click)=\"save(false, true)\">\r\n            <mat-icon>email</mat-icon>\r\n            <span [style.vertical-align]=\"'middle'\">Email</span>\r\n        </button>\r\n        <button mat-menu-item (click)=\"save(true, false)\">\r\n            <mat-icon>file_download</mat-icon>\r\n            <span [style.vertical-align]=\"'middle'\">Download</span>\r\n        </button>\r\n        <button mat-menu-item (click)=\"save()\">\r\n            <mat-icon>save</mat-icon>\r\n            <span [style.vertical-align]=\"'middle'\">Save</span>\r\n        </button>\r\n    </mat-menu>\r\n</div>\r\n\r\n<form [formGroup]=\"enquiryForm\" novalidate>\r\n    <div fxLayout=\"row\" fxLayoutAlign=\"space-between\" fxLayout.lt-md=\"column\">\r\n\r\n        <div fxFlex=\"32\" fxLayout=\"column\">\r\n            <div fxLayoutAlign=\"start center\" fxLayoutGap=\"10px\" class=\"section-header\">\r\n                <mat-icon class=\"header-icon\">looks_one</mat-icon>\r\n                <div>Provide Quote Details</div>\r\n                <hr fxFlex />\r\n            </div>\r\n\r\n            <mat-card fxFlex>\r\n                <mat-card-content>\r\n                    <div *ngIf=\"loadingEnquiryOptions\" fxLayout=\"row\" fxLayoutAlign=\"center\">\r\n                        <mat-spinner mode=\"indeterminate\"></mat-spinner>\r\n                    </div>\r\n                    \r\n                    <div *ngIf=\"showFinanceForm()\" fxLayout=\"column\" formGroupName=\"finance\">\r\n                        <!-- Vendor Program dropdown to filter introducerRateChartID dropdown. Not part of the actual form object-->\r\n                        <div *ngIf=\"showProgramFilter()\">\r\n                            <mat-form-field fxFlex.gt-md=\"50\">\r\n                                <mat-select placeholder=\"Vendor Program\" [formControl]=\"programFilterFC\" required>\r\n                                    <mat-option *ngFor=\"let opt of uniquePrograms\" [value]=\"opt.id\">\r\n                                        {{opt.label}}\r\n                                    </mat-option>\r\n                                </mat-select>\r\n                            </mat-form-field>\r\n                        </div>\r\n\r\n                        <div>\r\n                            <mat-form-field fxFlex.gt-md=\"50\">\r\n                                <mat-select placeholder=\"Finance Type\" formControlName=\"introducerRateChartID\" required>\r\n                                    <mat-option *ngFor=\"let irc of filteredIrcs\" [value]=\"irc.id\">\r\n                                        {{irc.productName}}\r\n                                    </mat-option>\r\n                                </mat-select>\r\n                            </mat-form-field>\r\n                        </div>\r\n\r\n                        <div *ngIf=\"showAssetTypeGroup()\">\r\n                            <mat-form-field fxFlex.gt-md=\"50\">\r\n                                <mat-select placeholder=\"Asset Type\" formControlName=\"assetTypeGroupID\" required>\r\n                                    <mat-option *ngFor=\"let assetTypeGroup of selectedIrc?.assetTypeGroups\" [value]=\"assetTypeGroup.id\">\r\n                                        {{assetTypeGroup.label}}\r\n                                    </mat-option>\r\n                                </mat-select>\r\n                            </mat-form-field>\r\n                        </div>\r\n\r\n                        <mat-form-field>\r\n                            <!-- Binding this formControl manually since it's inside the \"finance\" FormGroup -->\r\n                            <input matInput type=\"text\" placeholder=\"Goods Description\" [formControl]=\"enquiryForm.get('goodsDescription')\">\r\n                            <mat-error *ngIf=\"enquiryForm.get('goodsDescription').hasError('maxlength')\" align=\"end\">Max length 1000 characters.</mat-error>\r\n                        </mat-form-field>\r\n\r\n                        <div>\r\n                            <mat-form-field fxFlex.gt-md=\"50\">\r\n                                <span matPrefix>$ &nbsp;</span>\r\n                                <!--NOTE: keeping this as 'tel' input for now due to angular bug with valueChanges event firing twice for 'number' inputs (second time happening onblur).\r\n                                see - https://github.com/angular/angular/issues/12540 -->\r\n                                <input matInput type=\"tel\" placeholder=\"Cost of Goods\" formControlName=\"costOfGoods\" required>\r\n                                <span matSuffix>{{selectedIrc?.costOfGoodsIncGST ? 'Incl. GST' : 'Excl. GST'}}</span>\r\n                                <mat-error *ngIf=\"costOfGoodsFC.hasError('min')\" align=\"end\">Minimum {{selectedIrc.minCostOfGoods | currency:'AUD'}}</mat-error>\r\n                                <mat-error *ngIf=\"costOfGoodsFC.hasError('max')\" align=\"end\">Maximum {{selectedIrc.maxCostOfGoods | currency:'AUD'}}</mat-error>\r\n                                <mat-error *ngIf=\"costOfGoodsFC.hasError('required')\" align=\"end\">Required.</mat-error>\r\n                                <mat-error *ngIf=\"costOfGoodsFC.hasError('pattern')\" align=\"end\">Please enter a number.</mat-error>\r\n                            </mat-form-field>\r\n                        </div>\r\n\r\n                        <div>\r\n                            <mat-checkbox formControlName=\"isAdvance\">Payment in Advance</mat-checkbox>\r\n                        </div>\r\n                    </div>\r\n                </mat-card-content>\r\n            </mat-card>\r\n        </div>\r\n\r\n        <div fxFlex=\"32\" fxLayout=\"column\">\r\n            <div fxLayoutAlign=\"start center\" fxLayoutGap=\"10px\" class=\"section-header\">\r\n                <mat-icon class=\"header-icon\">looks_two</mat-icon>\r\n                <div>Select Repayment Option</div>\r\n                <hr fxFlex />\r\n            </div>\r\n\r\n            <mat-card fxFlex>\r\n                <mat-card-content>\r\n                    <div *ngIf=\"showSubmittedRepaymentOption(); else repaymentOptionsArea\">\r\n                        <mat-list dense>\r\n                            <h3 matSubheader>Submitted Repayment Option</h3>\r\n                            <mat-list-item style=\"background-color: #f5f5f5;\">\r\n                                <!--TODO: unhardcode this background color.. should come from material theme-->\r\n                                <mat-icon matListIcon>done</mat-icon>\r\n                                <p matLine>{{enquiry.repayment | currency:'AUD'}} per {{getSingularFrequencyDesc(enquiry.paymentFrequencyName)}}</p>\r\n                                <p matLine>For {{enquiry.term}} months</p>\r\n                                <p matLine>{{getResidualLabel()}}: {{enquiry.residualAmount | currency:'AUD'}}</p>\r\n                            </mat-list-item>\r\n                        </mat-list>\r\n                    </div>\r\n\r\n                    <ng-template #repaymentOptionsArea>\r\n                        <div *ngIf=\"showFinanceInvalidMessage()\" fxLayoutAlign=\"center\">\r\n                            <p>Please enter financial details to view repayment options.</p>\r\n                        </div>\r\n\r\n                        <div *ngIf=\"showRepaymentsSpinner()\" fxLayoutAlign=\"center\">\r\n                            <mat-spinner mode=\"indeterminate\"></mat-spinner>\r\n                        </div>\r\n                        \r\n                        <!-- Creating a subscription using ngIf here allows us to get away with just one subscription - https://github.com/angular/angular/issues/13061 -->\r\n                        <mat-radio-group *ngIf=\"repaymentOptions$ | async as opts\" [formControl]=\"repaymentOptionFC\">\r\n                            <div *ngIf=\"showRepaymentsList()\">\r\n                                <!-- Note: haven't used flex-layout for this repayment options table, because the sample CSS already had media queries -->\r\n                                <ul class=\"pricing-table\">\r\n                                    <li class=\"price-block\" *ngFor=\"let freq of selectedIrc?.paymentFrequencies\" \r\n                                            [ngClass]=\"{'price-block-selected': repaymentOptionFC.value?.paymentFrequencyID == freq.id }\">\r\n\r\n                                        <h4>{{freq.label}}</h4>\r\n                                        <div *ngFor=\"let opt of getFilteredRepaymentOptions(freq.id, opts)\" class=\"price\"\r\n                                                (click)=\"repaymentOptionFC.setValue(opt)\"\r\n                                                [ngClass]=\"{'price-selected': isRepaymentOptionSelected(opt) }\">\r\n\r\n                                            <div class=\"price-figure\">\r\n                                                <span class=\"price-number\">{{opt.repayment | currency:'AUD'}}</span>\r\n                                                <span class=\"price-tenure\">per {{getSingularFrequencyDesc(opt.paymentFrequencyName)}}</span>\r\n                                                <span class=\"price-tenure\">for {{opt.term}} months</span>\r\n                                                <span *ngIf=\"showResidual()\" class=\"price-tenure\">\r\n                                                    {{getResidualLabel()}} {{opt.residualAmount | currency:'AUD'}}\r\n                                                </span>\r\n                                            </div>\r\n                                        </div>\r\n                                    </li>\r\n                                </ul>\r\n                            </div>\r\n                        </mat-radio-group>\r\n                    </ng-template>\r\n                </mat-card-content>\r\n            </mat-card>\r\n        </div>\r\n\r\n        <div fxFlex=\"32\" fxLayout=\"column\">\r\n            <div fxLayoutAlign=\"start center\" fxLayoutGap=\"10px\" class=\"section-header\">\r\n                <mat-icon class=\"header-icon\">looks_3</mat-icon>\r\n                <div>Provide Contact Details</div>\r\n                <hr fxFlex />\r\n            </div>\r\n\r\n            <mat-card fxFlex>\r\n                <mat-card-content>\r\n                    <div fxLayout=\"column\">\r\n                        <mat-form-field>\r\n                            <input matInput type=\"text\" placeholder=\"Contact Name\" formControlName=\"contactName\" required>\r\n                            <mat-error *ngIf=\"enquiryForm.get('contactName').hasError('maxlength')\" align=\"end\">Max length 100 characters.</mat-error>\r\n                            <mat-error *ngIf=\"enquiryForm.get('contactName').hasError('required')\" align=\"end\">Required.</mat-error>\r\n                        </mat-form-field>\r\n\r\n                        <mat-form-field>\r\n                            <input matInput type=\"text\" placeholder=\"Business Name\" formControlName=\"businessName\" required>\r\n                            <mat-error *ngIf=\"enquiryForm.get('businessName').hasError('maxlength')\" align=\"end\">Max length 100 characters.</mat-error>\r\n                            <mat-error *ngIf=\"enquiryForm.get('businessName').hasError('required')\" align=\"end\">Required.</mat-error>\r\n                        </mat-form-field>\r\n\r\n                        <mat-form-field>\r\n                            <input matInput type=\"text\" placeholder=\"ABN\" formControlName=\"abn\" maxlength=\"11\" #abnInput>\r\n                            <mat-hint align=\"end\">{{abnInput.value.length}} / 11</mat-hint>\r\n                        </mat-form-field>\r\n\r\n                        <div formGroupName=\"phoneNumbers\" fxLayout=\"column\">\r\n                            <mat-form-field>\r\n                                <input matInput type=\"tel\" placeholder=\"Phone\" formControlName=\"phone\" maxlength=\"20\">\r\n                                <!--workaround for mat-error with a custom validator - see https://github.com/angular/material2/issues/4027 -->\r\n                                <mat-hint *ngIf=\"showPhoneError()\" align=\"end\" style=\"color:red\">Please provide either a phone or mobile number.</mat-hint>\r\n                            </mat-form-field>\r\n\r\n                            <mat-form-field>\r\n                                <input matInput type=\"tel\" placeholder=\"Mobile\" formControlName=\"mobile\" maxlength=\"20\">\r\n                            </mat-form-field>\r\n                        </div>\r\n\r\n                        <mat-form-field>\r\n                            <input matInput type=\"email\" placeholder=\"Email\" formControlName=\"emailAddress\" required>\r\n                            <mat-error *ngIf=\"enquiryForm.get('emailAddress').hasError('maxlength')\" align=\"end\">Max length 100 characters.</mat-error>\r\n                            <mat-error *ngIf=\"enquiryForm.get('emailAddress').hasError('required')\" align=\"end\">Required.</mat-error>\r\n                        </mat-form-field>\r\n\r\n                        <mat-form-field>\r\n                            <input matInput type=\"text\" placeholder=\"Address\" formControlName=\"address\">\r\n                            <mat-error *ngIf=\"enquiryForm.get('address').hasError('maxlength')\" align=\"end\">Max length 200 characters.</mat-error>\r\n                        </mat-form-field>\r\n\r\n                        <mat-form-field>\r\n                            <textarea matInput placeholder=\"Notes\" formControlName=\"notes\" rows=\"5\"></textarea>\r\n                            <mat-error *ngIf=\"enquiryForm.get('notes').hasError('maxlength')\" align=\"end\">Max length 500 characters.</mat-error>\r\n                        </mat-form-field>\r\n\r\n                        <div *ngIf=\"enquiry?.submittedOn\" class=\"message\">\r\n                            Submitted on {{enquiry?.submittedOn | date:'medium'}}.\r\n                        </div>\r\n\r\n                        <div fxLayoutAlign=\"end\" fxLayoutAlign.lt-md=\"start\" class=\"small-spinner\">\r\n                            <mat-spinner *ngIf=\"showSubmissionSpinner()\" mode=\"indeterminate\"></mat-spinner>\r\n                        </div>\r\n                    </div>\r\n                </mat-card-content>\r\n                <mat-card-actions>\r\n                    <div fxLayoutAlign=\"end\" fxLayoutAlign.lt-md=\"start\">\r\n                        <button mat-raised-button type=\"button\" color=\"primary\" (click)=\"submit()\" [disabled]=\"actionsDisabled()\">SUBMIT</button>\r\n                    </div>\r\n                </mat-card-actions>\r\n            </mat-card>\r\n        </div>\r\n\r\n    </div>\r\n</form>";

/***/ }),

/***/ 646:
/***/ (function(module, exports) {

module.exports = "/* IE specific fix. IE seems to have trouble with the mat-card heights, and\r\n    we don't really need to worry about mobile layout for IE https://stackoverflow.com/a/36448860 \r\n    The enquiry detail screen is currently the only page where we want the mat-card heights to match like this.\r\n*/\r\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\r\n   mat-card {\r\n        min-height: 740px;\r\n   }\r\n}\r\n\r\n.message {\r\n    font-size: 14px;\r\n}\r\n\r\n.header-icon {\r\n    color: grey;\r\n}\r\n\r\n.section-header {\r\n    margin-top: 15px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n/*  Repayments grid CSS below\r\n *  Modified from http://webdesign.tutsplus.com/tutorials/build-a-responsive-pricing-table-with-neat-hover-states--webdesign-12037\r\n *  Demo: http://source.tutsplus.com/webdesign/tutorials/025_css-pricing-tables/index.html\r\n*/\r\n\r\n/*----------\r\nBlocks\r\n----------*/\r\n/*Pricing table and price blocks*/\r\n.pricing-table {\r\n\tline-height: 150%; \r\n\tfont-size: 12px; \r\n\tmax-width: 800px; \r\n\tpadding: 10px;\r\n    cursor: pointer;\r\n}\r\n\t\t\r\n.price-block {\r\n\ttext-align: center; \r\n\twidth: 100%; \r\n\tcolor: #fff; \r\n\tfloat: left; \r\n\tlist-style-type: none; \r\n\ttransition: all 0.25s; \r\n\tposition: relative; \r\n\tbox-sizing: border-box;\r\n\tmargin-bottom: 10px; \r\n\tborder-bottom: 1px solid transparent; \r\n}\r\n\t\t\r\n/*Price heads*/\r\n.pricing-table h4 {\r\n\ttext-transform: uppercase; \r\n\tpadding: 5px 0; \r\n\tbackground: #666; \r\n\tmargin: -10px 0 1px 0;\r\n}\r\n\t\t\r\n/*Price tags*/\r\n.price {\r\n\tdisplay: table; \r\n\tbackground: #777; \r\n\twidth: 100%; \r\n\theight: 70px; \r\n}\r\n\r\n.price-figure {\r\n\tfont-size: 18px; \r\n\ttext-transform: uppercase; \r\n\tvertical-align: middle; \r\n\tdisplay: table-cell;\r\n    border-bottom: 1px solid #ccc; \r\n    padding: 5px;\r\n}\r\n\r\n.price-number {\r\n\tfont-weight: bold; \r\n\tdisplay: block;\r\n}\r\n\r\n.price-tenure {\r\n\tfont-size: 11px; \r\n    display: block;\r\n}\r\n\t\t\r\n/*Features*/\r\n.features {\r\n\tbackground: #DEF0F4; \r\n\tcolor: #000;\r\n    padding-left: 0px;\r\n}\r\n\r\n.features li {\r\n\tpadding: 8px 15px;\r\n\tborder-bottom: 1px solid #ccc; \r\n\tfont-size: 11px; \r\n\tlist-style-type: none;\r\n}\r\n\t\t\r\n.footer {\r\n\tpadding: 10px; \r\n\tbackground: #DEF0F4;\r\n}\r\n\r\n.action-button {\r\n\ttext-decoration: none; \r\n\tcolor: #fff; \r\n\tfont-weight: bold; \r\n\tborder-radius: 5px; \r\n\tbackground: linear-gradient(#666, #333); \r\n\tpadding: 5px 20px; \r\n\tfont-size: 11px; \r\n\ttext-transform: uppercase;\r\n}\r\n\r\n.price-block-selected {\r\n\tbox-shadow: 0 0 0px 5px rgba(0, 0, 0, 0.5); \r\n\ttransform: scale(1.04) translateY(-5px); \r\n\tz-index: 1; \r\n\tborder-bottom: 0 none;\r\n}\r\n\r\n.price-block-selected .price-selected {\r\n\tbackground: #419639;\r\n}\r\n\r\n.price-block-selected h4 {\r\n\tbackground: #555;\r\n}\r\n\t\t\r\n@media only screen and (min-width : 480px) and (max-width : 768px) {\r\n\t.price-block {width: 50%;}\r\n\t.price-block:nth-child(odd) {border-right: 1px solid transparent;}\r\n\t.price-block:nth-child(3) {clear: both;}\r\n}\r\n@media only screen and (min-width : 768px){\r\n\t.price-block {width: 33%;}\r\n\t.price-block {border-right: 1px solid transparent; border-bottom: 0 none;}\r\n\t.price-block:last-child {border-right: 0 none;}\r\n}"

/***/ }),

/***/ 647:
/***/ (function(module, exports) {

module.exports = "<h2 matDialogTitle>Email History</h2>\r\n\r\n<mat-dialog-content>\r\n    <div *ngIf=\"loading\" fxLayout=\"row\" fxLayoutAlign=\"center\" class=\"email-history-spinner\">\r\n        <mat-spinner mode=\"indeterminate\"></mat-spinner>\r\n    </div>\r\n\r\n    <div *ngIf=\"!loading\" class=\"email-content\">\r\n        <div *ngFor=\"let email of emailList\" fxLayout=\"column\">\r\n            <h4>Quote emailed at {{email.createdOn | date:'medium'}} by {{email.createdBy}}</h4>\r\n\r\n            <div fxLayout.gt-md=\"row\" fxLayout=\"column\" fxLayoutAlign=\"space-between\">\r\n                <div fxFlex=\"48\" fxLayout=\"column\" fxLayoutGap=\"5px\">\r\n                    <div>\r\n                        <span class=\"label\">To:</span>\r\n                        <span>{{email.to}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span class=\"label\">CC:</span>\r\n                        <span>{{email.cc}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span class=\"label\">BCC:</span>\r\n                        <span>{{email.bcc}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span class=\"label\">User Attached Files:</span>\r\n                        <span>{{email.attachmentFileNames}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span class=\"label\">Subject:</span>\r\n                        <span>{{email.subject}}</span>\r\n                    </div>\r\n                </div>\r\n\r\n                <div fxFlex=\"48\" fxLayout=\"column\" fxLayoutGap=\"5px\">\r\n                    <div>\r\n                        <span class=\"label\">Asset Cost Shown:</span>\r\n                        <span>{{email.quoteDocGenData?.showAssetCost ? 'Yes' : 'No'}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span class=\"label\">Included Repayment Options:</span>\r\n                    </div>\r\n                    <ul>\r\n                        <li *ngFor=\"let opt of email.quoteDocGenData?.repaymentOptions\">\r\n                            {{opt.paymentFrequencyName}} for {{opt.term}} months: {{opt.repayment | currency:'AUD'}}\r\n                            <div>\r\n                                <span *ngIf=\"opt.residualLabelAsBalloon\">Balloon Amount: </span>\r\n                                <span *ngIf=\"!opt.residualLabelAsBalloon\">Residual Value: </span>\r\n                                {{opt.residualAmount | currency:'AUD'}}\r\n                            </div>\r\n                        </li>\r\n                    </ul>\r\n                </div>\r\n            </div>\r\n\r\n            <mat-form-field class=\"email-content\">\r\n                <textarea matInput [value]=\"email.body\" matTextareaAutosize disabled></textarea>\r\n            </mat-form-field>\r\n        </div>\r\n    </div>\r\n</mat-dialog-content>\r\n\r\n<mat-dialog-actions align=\"end\">\r\n    <button mat-raised-button matDialogClose>CLOSE</button>\r\n</mat-dialog-actions>";

/***/ }),

/***/ 648:
/***/ (function(module, exports) {

module.exports = ".email-history-spinner {\r\n    height: 130px; /* Prevents the scrollbar from appearing on the dialog since the spinner height changes during animation */\r\n}\r\n\r\n.email-content {\r\n    font-size: 14px;\r\n}\r\n\r\n.label {\r\n    font-weight: 600;\r\n    margin-right: 5px;\r\n}"

/***/ }),

/***/ 649:
/***/ (function(module, exports) {

module.exports = "<div fxLayout=\"row wrap\" fxLayoutAlign=\"space-between center\">\r\n    <div fxLayout=\"row\" fxLayoutGap=\"10px\">\r\n        <mat-form-field>\r\n            <mat-select placeholder=\"Show Enquiries From\" [formControl]=\"monthsAgoFC\">\r\n                <mat-option *ngFor=\"let numMonths of monthOptions\" [value]=\"numMonths\">\r\n                    Last {{numMonths > 1 ? numMonths + ' Months' : 'Month' }}\r\n                </mat-option>\r\n                <mat-option [value]=\"0\">All Time</mat-option>\r\n            </mat-select>\r\n        </mat-form-field>\r\n\r\n        <mat-form-field class=\"search-box\">\r\n            <input matInput [formControl]=\"filterFC\" placeholder=\"Search (Reference/Names/Product)\">\r\n            <mat-icon matSuffix *ngIf=\"filterFC.value\" (click)=\"filterFC.reset()\" class=\"clear-search\">clear</mat-icon>\r\n        </mat-form-field>\r\n    </div>\r\n\r\n    <button mat-raised-button type=\"button\" (click)=\"goToNewEnquiry()\" color=\"primary\">NEW</button>\r\n</div>\r\n\r\n<div class=\"container fab-spacer\">\r\n    <div class=\"table-loading-shade\" *ngIf=\"loading\">\r\n        <mat-spinner></mat-spinner>\r\n    </div>\r\n    \r\n    <mat-table #table [dataSource]=\"dataSource\" class=\"enquiry-table\"\r\n                matSort matSortActive=\"createdOn\" matSortDisableClear matSortDirection=\"desc\">\r\n\r\n        <ng-container matColumnDef=\"enquiryNumber\">\r\n            <mat-header-cell *matHeaderCellDef mat-sort-header>\r\n                Reference\r\n            </mat-header-cell>\r\n            <mat-cell *matCellDef=\"let row\">\r\n                {{ row.enquiryNumber }}\r\n            </mat-cell>\r\n        </ng-container>\r\n\r\n        <ng-container matColumnDef=\"businessName\">\r\n            <mat-header-cell *matHeaderCellDef mat-sort-header>\r\n                Business Name\r\n            </mat-header-cell>\r\n            <mat-cell *matCellDef=\"let row\">\r\n                {{ row.businessName }}\r\n            </mat-cell>\r\n        </ng-container>\r\n\r\n        <ng-container matColumnDef=\"contactName\">\r\n            <mat-header-cell *matHeaderCellDef mat-sort-header>\r\n                Contact Name\r\n            </mat-header-cell>\r\n            <mat-cell *matCellDef=\"let row\">\r\n                {{ row.contactName }}\r\n            </mat-cell>\r\n        </ng-container>\r\n\r\n        <ng-container matColumnDef=\"product\">\r\n            <mat-header-cell *matHeaderCellDef mat-sort-header>\r\n                Product\r\n            </mat-header-cell>\r\n            <mat-cell *matCellDef=\"let row\">\r\n                {{ row.product }}\r\n            </mat-cell>\r\n        </ng-container>\r\n\r\n        <ng-container matColumnDef=\"costOfGoods\">\r\n            <mat-header-cell *matHeaderCellDef mat-sort-header fxLayoutAlign=\"end\">\r\n                Cost of Goods\r\n            </mat-header-cell>\r\n            <mat-cell *matCellDef=\"let row\" fxLayoutAlign=\"end center\">\r\n                {{ row.costOfGoods | currency:'AUD' }}\r\n            </mat-cell>\r\n        </ng-container>\r\n\r\n        <ng-container matColumnDef=\"term\">\r\n            <mat-header-cell *matHeaderCellDef mat-sort-header fxLayoutAlign=\"end\">\r\n                Term\r\n            </mat-header-cell>\r\n            <mat-cell *matCellDef=\"let row\" fxLayoutAlign=\"end center\">\r\n                {{ row.term }}\r\n            </mat-cell>\r\n        </ng-container>\r\n\r\n        <ng-container matColumnDef=\"repayment\">\r\n            <mat-header-cell *matHeaderCellDef mat-sort-header fxLayoutAlign=\"end\">\r\n                Repayment\r\n            </mat-header-cell>\r\n            <mat-cell *matCellDef=\"let row\" fxLayoutAlign=\"end center\">\r\n                {{ row.repayment | currency:'AUD' }}\r\n            </mat-cell>\r\n        </ng-container>\r\n\r\n        <ng-container matColumnDef=\"createdOn\">\r\n            <mat-header-cell *matHeaderCellDef mat-sort-header fxLayoutAlign=\"center\">\r\n                Created\r\n            </mat-header-cell>\r\n            <mat-cell *matCellDef=\"let row\" fxLayoutAlign=\"center center\">\r\n                {{ row.createdOn | date:'dd/MM/yyyy' }}\r\n            </mat-cell>\r\n        </ng-container>\r\n\r\n        <ng-container matColumnDef=\"lastEmailSentOn\">\r\n            <mat-header-cell *matHeaderCellDef mat-sort-header>\r\n                Last Email Sent\r\n            </mat-header-cell>\r\n            <mat-cell *matCellDef=\"let row\" fxLayoutAlign=\"start center\" fxLayoutGap=\"3px\">\r\n                <span>{{ row.lastEmailSentOn | date:'dd/MM/yyyy' }}</span>\r\n                <button *ngIf=\"row.lastEmailSentOn\" mat-icon-button type=\"button\" matTooltip=\"View Emails\" (click)=\"openEmailHistoryDialog(row.id)\">\r\n                    <mat-icon>mail</mat-icon>\r\n                </button>\r\n            </mat-cell>\r\n        </ng-container>\r\n\r\n        <ng-container matColumnDef=\"submittedOn\">\r\n            <mat-header-cell *matHeaderCellDef mat-sort-header>\r\n                Submitted\r\n            </mat-header-cell>\r\n            <mat-cell *matCellDef=\"let row\">\r\n                {{ row.submittedOn | date:'dd/MM/yyyy' }}\r\n            </mat-cell>\r\n        </ng-container>\r\n\r\n        <ng-container matColumnDef=\"actions\">\r\n            <mat-header-cell *matHeaderCellDef>\r\n                Actions\r\n            </mat-header-cell>\r\n            <mat-cell *matCellDef=\"let row\">\r\n                <button mat-icon-button type=\"button\" (click)=\"goToEnquiry(row.id)\">\r\n                    <mat-icon>edit</mat-icon>\r\n                </button>\r\n            </mat-cell>\r\n        </ng-container>\r\n\r\n        <mat-header-row *matHeaderRowDef=\"displayedColumns\"></mat-header-row>\r\n        <mat-row *matRowDef=\"let row; columns: displayedColumns;\"></mat-row>\r\n    </mat-table>\r\n\r\n    <mat-paginator [pageSize]=\"10\"></mat-paginator>\r\n</div>";

/***/ }),

/***/ 650:
/***/ (function(module, exports) {

module.exports = ".container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    position: relative;\r\n}\r\n\r\n.search-box {\r\n    width: 250px;\r\n}\r\n\r\n.clear-search {\r\n    cursor: pointer;\r\n}\r\n\r\n.enquiry-table {\r\n    /*overflow: auto;*/\r\n    min-width: 1200px;\r\n}\r\n\r\n.table-footer {\r\n    margin-top: 10px;\r\n    color: rgba(0,0,0,.54);\r\n    font-size: 14px;\r\n}\r\n\r\n.mat-column-businessName,\r\n.mat-column-contactName {\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.mat-column-product,\r\n.mat-column-createdOn,\r\n.mat-column-lastEmailSentOn,\r\n.mat-column-submittedOn {\r\n    max-width: 130px;\r\n}\r\n\r\n.mat-column-enquiryNumber,\r\n.mat-column-costOfGoods,\r\n.mat-column-repayment {\r\n    max-width: 100px;\r\n}\r\n\r\n.mat-column-term,\r\n.mat-column-actions {\r\n    max-width: 50px;\r\n}"

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var material_1 = __webpack_require__(29);
var router_1 = __webpack_require__(26);
var auth_service_1 = __webpack_require__(85);
var perspective_service_1 = __webpack_require__(87);
var theme_service_1 = __webpack_require__(107);
var change_password_dialog_component_1 = __webpack_require__(179);
var app_version_1 = __webpack_require__(277);
__webpack_require__(652); //App-wide styles
var AppComponent = /** @class */ (function () {
    function AppComponent(authService, dialog, perspectiveService, router, themeService) {
        this.authService = authService;
        this.dialog = dialog;
        this.perspectiveService = perspectiveService;
        this.router = router;
        this.themeService = themeService;
        this.appVersion = app_version_1.appVersion.Version;
        this.releaseDate = app_version_1.appVersion.ReleaseDate;
    }
    AppComponent.prototype.ngOnInit = function () {
    };
    AppComponent.prototype.toggleSearchInput = function () {
        var _this = this;
        this.showSearch = !this.showSearch;
        if (this.showSearch) {
            // probably shouldnt need this setTimeout?
            // https://github.com/angular/material2/issues/1474#issuecomment-293683513
            setTimeout(function () {
                _this.searchInput.focus();
            });
        }
    };
    AppComponent.prototype.onSubmit = function (searchValue) {
        this.router.navigate(["/enquiries", { "search": searchValue }]);
        this.searchInput.value = "";
        this.toggleSearchInput();
    };
    AppComponent.prototype.goTo = function (route) {
        this.sidenav.close();
        // force internal staff to set perspective before navigating
        if (this.showInternalStaffTools() && !this.perspectiveService.activeIntroducer) {
            this.router.navigate(["/perspective"]);
        }
        else {
            this.router.navigate([route]);
        }
    };
    AppComponent.prototype.logout = function () {
        this.sidenav.close();
        this.authService.logout();
        this.router.navigate(["/login"]);
    };
    AppComponent.prototype.openChangePasswordDialog = function () {
        this.sidenav.close();
        var dialogRef = this.dialog.open(change_password_dialog_component_1.ChangePasswordDialogComponent, {
            disableClose: true,
            data: {
                passwordChangeMandatory: false
            }
        });
    };
    AppComponent.prototype.perspectiveNotSet = function () {
        return this.authService
            && this.authService.userHasInternalStaffPermission
            && this.perspectiveService
            && !this.perspectiveService.activeIntroducer;
    };
    AppComponent.prototype.showInternalStaffTools = function () {
        return this.authService && this.authService.userHasInternalStaffPermission;
    };
    AppComponent.prototype.showWebAdminTools = function () {
        return this.authService && this.authService.userHasWebAdminPermission;
    };
    __decorate([
        core_1.ViewChild(material_1.MatInput),
        __metadata("design:type", material_1.MatInput)
    ], AppComponent.prototype, "searchInput", void 0);
    __decorate([
        core_1.ViewChild("sidenav"),
        __metadata("design:type", material_1.MatSidenav)
    ], AppComponent.prototype, "sidenav", void 0);
    AppComponent = __decorate([
        core_1.Component({
            selector: "faw-app",
            template: __webpack_require__(653),
            styles: [__webpack_require__(655)]
        }),
        __metadata("design:paramtypes", [auth_service_1.AuthService,
            material_1.MatDialog,
            perspective_service_1.PerspectiveService,
            router_1.Router,
            theme_service_1.ThemeService])
    ], AppComponent);
    return AppComponent;
}());
exports.AppComponent = AppComponent;


/***/ }),

/***/ 652:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<mat-toolbar *ngIf=\"authService.loggedIn()\" [style.background]=\"themeService.primaryColour\" class=\"fixed-header\">\r\n    <mat-toolbar-row>\r\n        <div fxFlex=\"33\" fxLayoutAlign=\"start center\">\r\n            <img *ngIf=\"!themeService.navbarLogo; else introducerLogo\" [fxHide.xs]=\"showSearch\" src=\"" + __webpack_require__(654) + "\" class=\"navbar-logo\" />\r\n            <ng-template #introducerLogo>\r\n                <img [fxHide.xs]=\"showSearch\" [src]=\"themeService.navbarLogo\" class=\"navbar-logo\" />\r\n            </ng-template>\r\n        </div>\r\n\r\n        <div fxFlex=\"33\">\r\n            <div fxHide.lt-md fxLayout=\"row\" fxLayoutAlign=\"center center\" fxLayoutGap=\"5px\" *ngIf=\"perspectiveService.activeIntroducer\">\r\n                <mat-icon>visibility</mat-icon>\r\n                <span>{{perspectiveService.activeIntroducer.entityName}}</span>\r\n            </div>\r\n        </div>\r\n\r\n        <div fxFlex=\"33\" fxLayoutAlign=\"end center\">\r\n            <mat-form-field floatPlaceholder=\"never\" [style.display]=\"showSearch ? null : 'none'\">\r\n                <input matInput placeholder=\"Search\" #searchInput (keyup.enter)=\"onSubmit(searchInput.value)\" maxlength=\"50\">\r\n            </mat-form-field>\r\n            <button *ngIf=\"!perspectiveNotSet()\" mat-icon-button type=\"button\" (click)=\"toggleSearchInput()\">\r\n                <mat-icon *ngIf=\"!showSearch\">search</mat-icon>\r\n                <mat-icon *ngIf=\"showSearch\">cancel</mat-icon>\r\n            </button>\r\n            <button mat-icon-button type=\"button\" (click)=\"sidenav.toggle()\"><mat-icon>menu</mat-icon></button>\r\n        </div>\r\n    </mat-toolbar-row>\r\n</mat-toolbar>\r\n\r\n<mat-sidenav-container>\r\n    <mat-sidenav #sidenav position=\"end\">\r\n        <mat-list>\r\n          <mat-list-item>\r\n            <h4 matLine>{{authService.userProfile?.fullName}}</h4>\r\n            <p matLine *ngIf=\"authService.userProfile?.jobTitle\">{{authService.userProfile?.jobTitle}}</p>\r\n          </mat-list-item>\r\n        </mat-list>\r\n\r\n        <mat-nav-list>\r\n            <mat-divider></mat-divider>\r\n\r\n            <mat-list-item (click)=\"goTo('/enquiries')\">\r\n                <a matLine>Enquiries</a>\r\n                <mat-icon>view_list</mat-icon>\r\n            </mat-list-item>\r\n\r\n            <mat-list-item (click)=\"goTo('/perspective')\" *ngIf=\"showInternalStaffTools()\">\r\n                <a matLine>Perspective</a>\r\n                <mat-icon>visibility</mat-icon>\r\n            </mat-list-item>\r\n\r\n            <mat-list-item (click)=\"goTo('/users')\" *ngIf=\"showWebAdminTools()\">\r\n                <a matLine>Manage Users</a>\r\n                <mat-icon>people</mat-icon>\r\n            </mat-list-item>\r\n\r\n            <mat-list-item (click)=\"goTo('/theme')\" *ngIf=\"showWebAdminTools()\">\r\n                <a matLine>Theme Settings</a>\r\n                <mat-icon>format_color_fill</mat-icon>\r\n            </mat-list-item>\r\n\r\n            <mat-list-item (click)=\"openChangePasswordDialog()\">\r\n                <a matLine>Change Password</a>\r\n                <mat-icon>lock</mat-icon>\r\n            </mat-list-item>\r\n\r\n            <mat-divider></mat-divider>\r\n\r\n            <mat-list-item (click)=\"logout()\">\r\n                <a matLine>Sign Out</a>\r\n                <mat-icon>exit_to_app</mat-icon>\r\n            </mat-list-item>\r\n        </mat-nav-list>\r\n\r\n        <div class=\"version-text\">\r\n            <span>Version {{appVersion}} [{{releaseDate}}]</span>\r\n        </div>\r\n    </mat-sidenav>\r\n\r\n    <div class=\"content-area\">\r\n        <router-outlet></router-outlet>\r\n    </div>\r\n</mat-sidenav-container>";

/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/faw-logo-navbar.b27db7a4734bc135b391a03ab2d33393.png";

/***/ }),

/***/ 655:
/***/ (function(module, exports) {

module.exports = ".version-text {\r\n    text-align: right; \r\n    padding-top: 10px; \r\n    padding-right: 10px; \r\n    font-size: 12px\r\n}"

/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var perspective_service_1 = __webpack_require__(87);
// see https://angular.io/guide/http#intercepting-all-requests-or-responses
// this interceptor appends the active introducer ID to the query string of any request - only relevent for internal staff users.
var PerspectiveInterceptor = /** @class */ (function () {
    function PerspectiveInterceptor(perspectiveService) {
        this.perspectiveService = perspectiveService;
    }
    PerspectiveInterceptor.prototype.intercept = function (req, next) {
        var activeIntroducerID = this.perspectiveService.getActiveIntroducerID();
        if (activeIntroducerID) {
            var reqWithParam = req.clone({ params: req.params.set("activeIntroducerID", this.perspectiveService.getActiveIntroducerID()) });
            return next.handle(reqWithParam);
        }
        else {
            return next.handle(req);
        }
    };
    PerspectiveInterceptor = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [perspective_service_1.PerspectiveService])
    ], PerspectiveInterceptor);
    return PerspectiveInterceptor;
}());
exports.PerspectiveInterceptor = PerspectiveInterceptor;


/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var http_1 = __webpack_require__(33);
var router_1 = __webpack_require__(26);
var angular_jwt_1 = __webpack_require__(172);
var rxjs_1 = __webpack_require__(4);
var operators_1 = __webpack_require__(6);
var handle_error_1 = __webpack_require__(86);
var perspective_service_1 = __webpack_require__(87);
var role_const_1 = __webpack_require__(177);
var theme_service_1 = __webpack_require__(107);
var AuthService = /** @class */ (function () {
    function AuthService(http, jwtService, perspectiveService, role, router, themeService) {
        this.http = http;
        this.jwtService = jwtService;
        this.perspectiveService = perspectiveService;
        this.role = role;
        this.router = router;
        this.themeService = themeService;
        this._userProfile = JSON.parse(localStorage.getItem("profile"));
    }
    ;
    Object.defineProperty(AuthService.prototype, "userProfile", {
        get: function () {
            return this._userProfile;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "userHasInternalStaffPermission", {
        get: function () {
            return this._userProfile
                ? this._userProfile.role === this.role.internalStaff
                : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "userHasWebAdminPermission", {
        get: function () {
            return this._userProfile
                ? (this._userProfile.role === this.role.internalStaff || this._userProfile.role === this.role.webAdmin)
                : false;
        },
        enumerable: true,
        configurable: true
    });
    AuthService.prototype.handleTokenRequestError = function (errResponse) {
        var message;
        if (errResponse.error != null && errResponse.error.error === "invalid_grant") {
            var oauthError = errResponse.error;
            message = oauthError.error_description;
        }
        else {
            message = errResponse.statusText + " (" + errResponse.status + ")";
        }
        return rxjs_1.throwError(message);
    };
    AuthService.prototype.changePassword = function (dto) {
        var url = "api/profile/change-password";
        return this.http.post(url, dto)
            .toPromise()
            .catch(handle_error_1.handleError);
    };
    AuthService.prototype.loggedIn = function () {
        if (this.jwtService.tokenGetter()) {
            return (!this.jwtService.isTokenExpired() && this.userProfile != null);
        }
        else {
            return false;
        }
    };
    AuthService.prototype.login = function (creds) {
        var _this = this;
        var body = "grant_type=password&username=" + creds.username + "&password=" + creds.password;
        return this.http
            .post("api/connect/token", body, {
            headers: new http_1.HttpHeaders().set("Content-Type", "application/x-www-form-urlencoded")
        })
            .pipe(operators_1.catchError(this.handleTokenRequestError), operators_1.flatMap(function (data) {
            localStorage.setItem("access_token", data.access_token);
            return _this.http.get("api/profile")
                .toPromise()
                .then(function (profile) {
                localStorage.setItem("profile", JSON.stringify(profile));
                _this._userProfile = profile;
                // internal staff have their theme set via the perspective component
                if (!_this.userHasInternalStaffPermission) {
                    // themeService has its own "handleError" function
                    _this.themeService.getTheme()
                        .catch(function (err) { return console.log("Error retrieving theme settings."); });
                }
                return profile;
            })
                .catch(handle_error_1.handleError);
        }));
    };
    AuthService.prototype.logout = function () {
        localStorage.removeItem("access_token");
        localStorage.removeItem("profile");
        this._userProfile = null;
        this.themeService.removeActiveTheme();
        // only relevant for internal staff users
        this.perspectiveService.removeActiveIntroducer();
    };
    AuthService = __decorate([
        core_1.Injectable(),
        __param(3, core_1.Inject(role_const_1.role)),
        __metadata("design:paramtypes", [http_1.HttpClient,
            angular_jwt_1.JwtHelperService,
            perspective_service_1.PerspectiveService, Object, router_1.Router,
            theme_service_1.ThemeService])
    ], AuthService);
    return AuthService;
}());
exports.AuthService = AuthService;


/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function handleError(err) {
    var rejectWithMessage = "Unexpected error occurred - please contact an administrator if the issue persists.";
    if (err.error instanceof Error) {
        // A client-side or network error occurred. Handle it accordingly.
        rejectWithMessage = "Client error occurred - please contact an administrator if the issue persists.";
        console.log("Client error: " + err.error.message);
    }
    else if (err.error && err.error.displayMessage) {
        // if the response body is json and "displayMessage" exists, then assume it's
        // an instance of PortalServerErrorException
        rejectWithMessage = "Server error (" + err.status + "): " + err.error.displayMessage;
        console.log("Server error (" + err.status + "): " + err.error.logMessage);
    }
    else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        if (err.status == 401) {
            rejectWithMessage = "Security token expired - please login again.";
        }
        else {
            rejectWithMessage = "Server error (" + err.status + ") - please contact an administrator if the issue persists.";
            console.log("Server error (" + err.status + "): " + err.error);
        }
    }
    return Promise.reject(rejectWithMessage);
}
exports.handleError = handleError;


/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1);
var PerspectiveService = /** @class */ (function () {
    function PerspectiveService() {
        this._activeIntroducer = JSON.parse(localStorage.getItem("active_introducer"));
    }
    Object.defineProperty(PerspectiveService.prototype, "activeIntroducer", {
        get: function () {
            //if (!this.activeIntroducer) {
            //    this.router.navigate(["/perspective"]);
            //}
            return this._activeIntroducer;
        },
        set: function (value) {
            // save to localStorage incase user refreshes the browser
            localStorage.setItem("active_introducer", JSON.stringify(value));
            this._activeIntroducer = value;
        },
        enumerable: true,
        configurable: true
    });
    PerspectiveService.prototype.getActiveIntroducerID = function () {
        return this._activeIntroducer
            ? this._activeIntroducer.entityID.toString()
            : null;
    };
    PerspectiveService.prototype.removeActiveIntroducer = function () {
        localStorage.removeItem("active_introducer");
        this._activeIntroducer = null;
    };
    PerspectiveService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [])
    ], PerspectiveService);
    return PerspectiveService;
}());
exports.PerspectiveService = PerspectiveService;


/***/ })

},[614]);


// WEBPACK FOOTER //
// dist/app.c49420e8f9280dc70662.js